let lang = {
   activitytop1:'限时狂欢',
   activitytop2:'企业流量1000GB套餐：',
   activitytop3:'个人流量80GB套餐：',
   activitytop4:'现仅需',
   activitytop5:'限时 ',
   
   activitytitle1:'限时活动 · 年度最大优惠',
   activitytitle2:'全球住宅IP代理',
   activitytitle3:'限时特惠 · 10 天',
   activitytext1:'来自全球 210+ 地区、6000 万+ 道德来源住宅 IP 池。活动期间下单立享专属优惠价,数量有限,先到先得。',
   activitytext2:'个人 80GB 仅 $0.8/GB',
   activitytext3:'企业套餐低至 $0.45/GB',
   activitytext4:'覆盖全球 210+ 地区',
   
   activitytime1:'距离结束',
   activityprice1:'限时优惠',
   
   selectlanguage:'选择文本语言',
   transfer1:'企业划转到个人',
   transfer2:'划转',
   transfer3:'请输入划转流量',
   transferSuccess: '划转成功',
    loading:'加载中...',
    searchText:'搜索',
    proxyAccountPlaceholder:'请输入账户名称',
    priceText1:'小计',
    expireTime:'有效期',
    productNewName:'住宅代理',
    loginLeftTitle2:'© 2026 BunnyProxy Inc. · 全球领先的住宅代理服务商',
    loginLeftTitle3:'屡获殊荣的网络智慧解决方案',

  useCouponsMsg:'请使用正确的优惠券',
  discountPrice:'折上折',
  springText:'春季特惠',
  huodongT1: "IPRocket周年庆活动震撼来袭！",
    huodongT2: "流量价格低至5元/G,10G起购！",
    huodongT3: "活动时间：2024年11月22日-11月28日（UTC+0）",
    buynow:'立即购买',
    Trial:"Trial",
    max_length: '输入长度最大为',
    last_length: '位',
    max_num:'最大值不能超过',
test:"test",
  home: '首页',
  product: '产品',
  price: '价格',
  priceNew: '价格',
  demo: '使用案例',
  resources: '资源',
  panel1Title1: '高质量住宅代理，无与伦比的价格！快速且稳定',
  panel1tip1: '6000多万个符合道德标准的IP',
  panel1tip12: '9000多万个符合道德标准的IP',
  panel1tip2: '支持HTTP(s)和Socks5',
  panel1tip3: '成功率超过99.05%',
  panel1tip32: '成功率超过99.86%',
  panel1tip4: '城市和州级定位',
  panel1tip5: '无并发会话和宽带限制',
  panel1tip6: '24/7技术支持',
    login_detailedAddress:'详细地址',
    login_phonenumber:'电话号码',
    login_companyName:'公司名称',
    login_companyAddress:'公司地址',
    login_email: '电子邮件地址',
    login_noaccount: '没有账户?',
    login_gologin: '注册账号',
  emailName:'电子邮件',
  login_password: '密码',
  login_password_submit: '确认密码',
  login_verifyCode: '验证码',
  login_now: '立即登录',
  have_account:'已有账户?',
  login_password_find: '找回密码',
  login_register_now: '立即注册',
  login_title: '登录',
  reset_password_title: '重设密码',
  register_title: '注册账号',
  or: '或',
  login_google: '使用谷歌登录',
  login_tip3: '我已阅读并同意',
  and: '和',
  check: '核实',
  register_account: '注册账号',
  new_password: '输入新密码',
  new_password_submit: '确认新密码',
  login_tip1: '输入您的帐户电子邮件地址，我们将发送一封',
  login_tip2: '验证码到您的电子邮件',
  send: '发送',
  logon_return: '回到登录',
  continue: '继续',
  login_title1: '全球代理',
  login_title2: '轻松的公共数据访问',
  login_title3: '灵活的定价',
  login_title4: '旋转和粘性会议',
  login_title5: '99.05%成功率',
  login_title6: '全天候支持团队',
  login_title7: '无限并发会话',
  login_title8: '请勾选服务条款和隐私协议',
  login_title9: '请输入完整登录信息',
  login_again: '修改成功，请重新登录',
  success: '成功',
  
  password_diff: '两次输入密码不一致',
  input_email: '请输入邮箱地址',
  email_error: '请输入正确的邮箱地址',
  input_password_again: '请再次输入密码',
    input_password: '密码为8-20位, 必须包含字母数字及特殊字符',
    input_password_6: '密码为6-15位, 必须包含字母数字及特殊字符',
  input_verifyCode: '请输入验证码',
    login_error: '登录失败',
    validateLength:'长度最多256个字符!',
    copy: '复制',
    copyAll: '复制全部',
    generateQRCode: '生成二维码',
    loginTEXT1: '邀请码',
    loginTEXT2: '确认您的电子邮件',
    loginTEXT3:'验证码已发送到您',
    loginTEXT4:'输入下面的代码',
    loginTEXT5:'您可以在',
    loginTEXT6: '秒后重新发送',
    loginTEXT7: '请检查您的spam folder或通过以下方式联系我们',
    loginTEXT8: '还没有收到电子邮件',
    loginTEXT9: '确认电子邮件',
    loginTEXT10:'下一步',
    loginTEXT11:'发送验证码',
    loginTEXT12:'重新输入你的密码',
    loginTEXT13: '重置密码',
    loginTEXT14: '人机验证码',
    loginTEXT15:'验证',
    loginTEXT16: '重新发送',
    loginTEXT17: '',
    loginLeftTitle:'欢迎来到 BUNNYPROXY',
    loginLeftText1: '24/7全天候客服支持',
    loginLeftText2: '定位任何国家（地区）、洲和城市',
    loginLeftText3: '99.86%  平均请求成功率',
    loginLeftText4: '符合道德来源的代理',
    loginLeftText5: '超过9000万真实IP',
    loginLeftText6:'欢迎加入BUNNYPROXY',
    loginLeftText7:'访问 6000万+ 真实住宅IP,开启您的全球数据采集之旅.一站式连接 195+ 国家与地区,稳定、合规、企业级安全。',

  // 仪表盘
  dashboard1: '总流量',
  dashboard2: '',
    dashboard3: '剩余流量',
    dashboard3_1: '使用流量',
  dashboard4: '当前余额',
  dashboard5: '添加余额',
  dashboard6: '总花费',
  dashboard7: '请输入兑换码(CDK)',
  dashboard8: '兑换',
  dashboard9: '生成兑换码(CDK)',
    dashboard10: '10的倍数',
    dashboard10_2:'2或10的倍数',
  dashboard11: '流量使用统计',
  dashboard12: '帮助中心',
  dashboard13: '联系我们',
  dashboard14: '常见问题',
  dashboard15: '您可以在文章中学习了解怎么使用代理',
  dashboard16: '快速指南',
  dashboard17: '您可以通过用户指南了解的一些功能和使用过程',
  dashboard18: '工具集成',
  dashboard19: '你可以在工具集成里协同工作，提升工作效率',
    dashboard20: '流量用量',
    dashboard21: '剩余提醒',
    dashboard22: '当个人计划GB量或天数低于您的选择时，将发送提醒。',
    dashboard23: '当企业计划GB量或天数低于您的选择时，将发送提醒。',
    dashboard23_all:'当个人/企业计划的剩余流量或剩余天数低于您的选择时，将在个人中心右上角发送提醒。',
    dashboard24: '剩余天数',
    dashboard25: '流量用量',
    dashboard26: '兑换码(CDK)',
    dashboard27: '钱包余额',
    dashboard28: '个人/企业计划提醒必须填写其中1个,并且大于0,才可开启提醒',
    dashboard29: '个人计划提醒',
    dashboard30: '企业计划提醒',
    dashboard31: '消息提醒',
    dashboard32: '我已知晓',
    dashboard33: '开',
    dashboard34: '关',
    dashboard35: '已读',
    dashboard36: '未读',
    dashboard37: '关闭',
    dashboard38:'暂无消息',
    dashboard39: '个人计划使用记录',
    dashboard40: '个人计划生效记录',
    dashboard41: '查看全部',
    dashboard42: '暂无消息',
    dashboard43: '保存',
    successful: '成功',
    Modification:'修改',
  // 仪表盘
  // 产品管理-价格
  price1: '计划',
  price2: '深入了解来自全球210多个地区的6000万+道德来源的住宅IP池。',
  price3: '请再次输入新密码',
  price4: '小贴士',
  price5: '可分配流量:企业计划流量可生成兑换码（CDK），用户兑换成个人计划流量后使用。',
  price6: '180天有效期:企业计划流量使用有效期为180 天，生成兑换码（CDK）使用有效期为180天，用户兑换成个人计划流量使用有效期为180天。',
  price7: '个人套餐',
  price8: '企业套餐',
  price9: '请输入旧密码',
  price10: '请输入新密码',
    price11: '请确认新密码',
    price12: '密码最高为20位',
    price13:'密码最低为8位',
    price14: '请输入密码',
  price15: '使用说明',
  price16: '企业套餐流量可转换为兑换码（CDK），供用户兑换后使用。',
  price17: '企业套餐流量',
  price18: 'CDK兑换码',
  price19: '兑换后个人套餐',
  price20: '180天',
  price21: '企业套餐',
  price22: '购买企业流量套餐',
  price23: '生成CDK',
  price24: '将企业套餐流量转换为CDK',
  price25: '用户兑换',
  price26: '用户使用CDK兑换流量',
  price27: '流量统计',
  price28: '用户获得个人可用流量',
  price29: '说明:每个阶段独立计算有效期180天',
  price30: '企业流量',
  // 产品管理-价格

  // 产品管理-获取IP
  reset: '重置',
  pleaseInput: '请输入',
  pleaseSelect: '请选择',
  country: '国家',
  city: '城市',
  format: '格式',
  count: '数量',
  generate1: '生成',
  operator: '运营商',
  ip1: '搜索类型',
  ip2: '选择州(省)-城市',
  ip3: '州/地区',
  ip4: '会话类型',
    ip5: '轮转代理为每次请求都更换一次IP地址,',
    ip5_1:'粘性模式可保持同一IP地址一定时间',
  ip6: '分钟数',
  ip7: '代理主机',
  ip8: '代理端口',
  ip9: '代理账户',
  ip10: '代理密码',
    ip11: '请输入8-15位的密码，由数字和字母组成',
    ip11_short: '请输入8-15位的密码',
    ip11_must:'必须同时包含大写字母、小写字母数字和特殊字符(@$!%*#?&.)',
  ip12: '基本curl示例',
  ip13: '账密认证',
  ip14: 'API获取',
  ip15: '非账号认证',
  ip16: '代理类型',
  ip17: '响应格式',
  ip18: '分隔符',
  ip19: '回车换行',
  ip20: '换行',
  ip21: '回车',
  ip22: '自定义字符',
  ip23: '复制链接',
  ip24: '打开链接',
  ip25: 'IP类型',
  ip26: '会话类型',
  ip27: '数量',
    ip28: '请输入',
    ip29: '常用国家',
    ip30: '代理格式',
    ip31: '代理列表',
    ip32: '链接格式',
    ip33: '链接列表',
    ip34:'生成规则',
    ip35:'轮转',
    ip36:'粘性',
    ip37:'会话时间',
  // 产品管理-获取IP

    // 产品管理-代理账户
    code_tip:'点击可生成二维码,多条数据仅第一条数据会生成二维码',
  add: '新增',
  enable: '启用',
  disable: '禁用',
  delete: '删除',
  operate: '操作',
  edit: '编辑',
  noData: '暂无数据',
  remark: '备注',
  cancel: '取消',
  confirm: '确定',
  tip: '提示',
  state: '状态',
  status: '状态',
    noEmpty: '不能为空',
  length5:'长度最高为5位',
    positiveInteger: '只能是正整数',
  accountList: '账户列表',
  proxyAccount1: '添加代理账号',
  proxyAccount2: '账号名称',
  proxyAccount3: '添加时间',
  proxyAccount4: '审批状态',
  proxyAccount5: '账户名',
  proxyAccount6: '请输入账户名',
  proxyAccount7: '流量上限',
  proxyAccount8: '请输入数字',
  proxyAccount9: '请输入备注',
  proxyAccount11: '确定要删除该代理账户吗',
  proxyAccount12: '请输入ip',
  proxyAccount13: '不限制',
    passwordLength: '密码长度为6-32位',

  passwordLength_15:'密码长度为6-15位,且不能含有空格',
  // 产品管理-代理账户
    error_100000: '最大值不能超过50000',
num_required:'数量最小为1',
  // 产品管理-白名单
  whitelist1: '添加白名单',
  whitelist2: '当前IP',
  whitelist3: '白名单IP',
  whitelist4: '请输入IP',
  whitelist5: '确定要删除该ip地址吗',
  // 产品管理-白名单

  // 产品管理-计划
  type: '类型',
  traffic: '流量',
  produce: '产生',
  generate: '产生',
  startTime: '开始时间',
  endTime: '结束时间',
  expireDate: '到期时间',
  search: '查询',
  remainder: '剩余',
  step1: '步骤1',
  step2: '步骤2',
  notUsed: '未使用',
  used: '已使用',
  invalid: '已失效',
  complete: '已完成',
  cdktype: '兑换码(CDK)兑换',
  cdktype2: '企业流量迁移',
  qrtx: '您确定要提交吗？',
  qrbt: '确认提交',
  plan1: '输入兑换码(CDK)',
  plan2: '购买流量',
  plan3: '剩余有效期（天）',
  plan4: '流量使用查询',
  plan5: '主账号',
  plan6: '子账号',
  plan7: '动态流量',
    plan8: '剩余流量',
    plan8_short:'使用流量',
  plan9: '销量',
  plan10: '如图1在图中位置输入您所需要生成的流量数(10或10的倍数)，随后点击右侧的”生成兑换码(CDK)”按钮。（兑换码(CDK)使用有效期为30天）',
  plan11: '如图2在图中位置输入您生成的兑换码(CDK)，随后点击右侧的”兑换”按钮，个人计划流量兑换成功后即可使用。',
  plan12: '操作日志',
  plan13: '账号名称',
    plan14: '如何生成和兑换兑换码(CDK)',
    plan14_text:'企业计划流量有效期为30天，当前企业计划流量有剩余流量时，用户再次获取的企业计划流量，会与当前剩余流量增加合并，使用有效期也将延长30天。',
  plan15: '操作时间',
  plan16: '生效中',
  plan17: '未生效',
  plan18: '个人计划使用指南',
  plan19: '获取方式',
    plan20: '用户官网购买个人计划流量套餐，或使用兑换码(CDK)兑换获取个人计划流量。',
    plan20_1: '用户官网购买个人计划流量套餐，或使用兑换码(CDK)兑换获取个人计划流量。',
  plan21: '生效条件',
  plan22: '个人计划流量获取完即时生效，首次使用个人计划流量的用户需等待1到3分钟。',
  plan22_1: '个人计划流量获取完即时生效，首次使用个人计划流量的用户需等待1到3分钟。',

    plan23: '候补机制',
    plan23_1: '续费机制',
  plan24: '当前个人计划流量有剩余流量时，用户再次获取的个人计划流量，会与当前剩余流量增加合并，使用有效期也将延长60天。',
  plan24_1: '当前有使用中的个人计划流量时，新购买的个人计划流量或兑换码(CDK)兑换获取的个人计划流量，将会依次排序列入未生效计划，待当前个人计划流量使用完毕或过期后，将根据排序依次自动生效。',
    plan25: '有效期',
  plan26: '每次新购买的个人计划流量，或兑换码(CDK)兑换获取的个人计划流量有效期为60天，以最后一次购买或兑换获取个人计划流量的时间为起始时间。',
  plan26_1: '每次新购买的个人计划流量，或兑换码(CDK)兑换获取的个人计划流量有效期为60天，个人计划流量生效时间为起始时间。',
    plan27: '类型',
  planall: '全部',
  planused: '已使用',
  planunused: '未使用',
  planexpired: '己失效',
  plancomplete: '已完成',
  plandiversion: '流量迁移',
  planczdx: '操作对象',
  planczll: '操作流量',
  planhzdx: '划转对象',
    planmasg: "划转对象和操作对象不能为同一人",
    plan28: '已过期',
    plan29: '已作废',
    plan29_1: '作废待审核',
    plan30: '佣金兑换流量',
    plan31: '企业计划购买',
    plan32: '兑换码(CDK)兑换',
    plan32_2:'兑换码(CDK)生成',
    plan33: '企业计划过期',
    plan34: '后台回收流量',
    plan35: '后台充值流量',
    plan36: '个人计划购买',
    plan37: '钱包续费流量',
    plan38: '个人计划过期',
    plan39: '受益用户',
    plan40: '兑换码(CDK)/交易号',
    plan41: '一键导出',
    plan42: '变动后余额($)',
    plan43: '变动后流量(GB)',
    plan44:'个人计划使用完毕',
  // 产品管理-计划

  // 账户管理-个人信息
  
  loginYour: '登录您的',
  creatYour: '创建您的',
  resetYour: '重置您的',
  account: '账号',
  email: '邮箱',
  save: '保存',
  profile1: '个人信息',
  profile2: '账号信息',
  profile3: '注册时间',
  profile4: '修改密码',
  profile5: '旧密码',
  profile6: '新密码',
  profile7: '再次确认',
    profile8: '修改成功',
    profile9: '名字',
    profile10: '姓氏',
    profile11: '居住国家',
    profile12: '省(州)',
  // 账户管理-个人信息

  // 账户管理-购买记录
  billing1: '购买记录',
  billing2: '兑换码(CDK)兑换记录',
  billing3: '请输入订单编号',
  billing4: '订单编号',
  billing5: '付款金额',
  billing6: '付款方式',
  billing7: '付款时间',
  billing8: '有效期限',
  billing9: '订单状态',
  billing10: '请输入兑换码(CDK)',
  billing11: '兑换流量',
  billing12: '兑换时间',
  // 账户管理-购买记录

  // 账户管理-推广分佣
  serialNumber: '序号',
  createTime: '创建时间',
  referralProgram1: '推荐新客户并获得奖励',
  referralProgram2: '您的推荐链接',
  referralProgram3: '复制生成的链接',
  referralProgram4: '使用它来分享和推荐IPRocket',
  referralProgram5: '获得每个被推荐客户订单的佣金',
  referralProgram6: '总收入',
  referralProgram7: '佣金提现',
  referralProgram8: '超值兑换',
  referralProgram9: '邀请交易记录',
  referralProgram10: '提现记录',
  referralProgram11: '兑换记录',
  referralProgram12: '用户账号',
  referralProgram13: '交易订单',
  referralProgram14: '交易金额',
  referralProgram15: '返佣比例',
  referralProgram16: '返佣金额',
    referralProgram17: '花费余额',
  referralProgram17_1: '提现金额',
  referralProgram18: '提现方式',
  referralProgram19: '提现账号',
  referralProgram20: '提现时间',
  referralProgram21: '提现状态',
  referralProgram22: '审核状态',
  referralProgram23: '审核结果',
  referralProgram24: '兑换金额',
  referralProgram25: '兑换流量',
  referralProgram26: '兑换时间',
  referralProgram27: '联盟横幅',
  referralProgram28: '横幅范例',
  referralProgram29: '横幅代码语言',
  referralProgram30: '横幅尺寸（像素）',
  referralProgram31: '提现金额必须大于$100并且只能是整数，每笔扣除2%手续费。',
  referralProgram32: '使用余额兑换流量时，输入流量数必须大于10GB并且只能是整数。住宅代理$0.8=1G，高级住宅代理$1=1G',
  referralProgram33: '虚拟货币(USDT)',
  referralProgram34: '钱包地址',
  referralProgram35: '钱包地址确认',
  referralProgram36: '两次钱包地址不一致',
  referralProgram37: '余额不足',
  referralProgram38: '邀请记录',
  referralProgram39: '交易量',
    referralProgram40: '我的佣金',
    referralProgram41: '请选择年份',
    referralProgram42: '请选择月份',
    referralProgram43: '查询',
    referralProgram44: '邀请好友加入IPRocket，赚取丰厚美金奖励!',
    referralProgram45: '每成功推荐一位好友购买，您将获得最高10%的现金奖励--奖励金额无限制，推广越多，赚得越多!',
    referralProgram46: '现在就复制您的专属推广链接，开始分享并赚取不封顶的现金收益吧!',
    referralProgram47: '分享推广链接或邀请码，推荐用户使用产品以获取奖励',
    referralProgram48: '默认链接/邀请码',
    referralProgram49: '点击数',
    referralProgram50: '分享至',
    referralProgram51: '数据摘要',
    referralProgram52: '刷新',
    referralProgram53: '周期',
    referralProgram54: '全部',
    referralProgram55: '奖励规则',
    referralProgram56: '推荐用户使用产品即可获得这些奖励',
    referralProgram57: '每成功推荐一位好友购买，您将获得最高10%的现金奖励！',
    referralProgram58: '预览',
    referralProgram59: '下载',
    referralProgram60: '上传',
    referralProgram61: 'IPRocket全球优质代理!',
    referralProgram62: '通过我们庞大的 90M+ 道德代理网络体验极速，提供 99.9% 的正常运行时间，实现无缝项目执行',
    referralProgram63: '提现',
    referralProgram64: '概览',
    referralProgram65: '链接',
    referralProgram66: '报表',
    referralProgram67: '提现申请',
    referralProgram68: '现金',
    referralProgram69: '提现应用',
    referralProgram70: '最低$100',
    referralProgram71: '2%手续费',
    referralProgram72: '确认TRC20钱包地址',
    referralProgram73: '输入提现后预计在7个工作日内到账',
    referralProgram74: '提现到账金额按处理当天的汇率计算，请确认信息无误，避免提现失败',
    referralProgram75: '充值流量',
    referralProgram76: '充值账户',
    referralProgram77: '账户',
    referralProgram78: '最低10G',
    referralProgram79: '时间',
    referralProgram79_1: '到期时间',
    referralProgram80: '受邀用户',
    referralProgram81: '趋势图',
    referralProgram82: '链接看板',
    referralProgram83: '注册数',
    referralProgram84: '提现中',
    referralProgram85: '已奖励',
    referralProgram86: '请选择状态',
    referralProgram87: '请输入受邀用户',
    referralProgram88: '日',
    referralProgram89: '月',
    referralProgram90: '提现中',
    referralProgram91: '提现完成',
    referralProgram92: '提现失败',
    referralProgram93: '请选择提现方式',
    referralProgram94: '请选择提现状态',
    referralProgram95: '代理流量',
    referralProgram96: '请输入提现金额',
    referralProgram97: '提现金额最低$100',
    referralProgram98: '输入类型不正确',
    referralProgram99: '请输入充值流量',
    referralProgram100: '充值流量最低10GB',
    referralProgram101: '请再次输入钱包地址',
    referralProgram102: '两次钱包地址输入不一致',
    referralProgram103: '请输入钱包地址',
    referralProgram104: '请选择提现应用',
    referralProgram105: '交易次数',
    referralProgram106:'已到账',
  // 账户管理-推广分佣

    // Rocket钱包
    Paymentsuccessful: '支付成功',
    PaddlePay:'Paddle支付',
  rechange: '充值',
  plan: '计划',
  discount: '折扣',
  rocket1: '充值记录',
  rocket2: '订单号码',
  rocket3: '金额',
  rocket4: '支付方式',
  rocket5: '购买时间',
  rocket6: '支付状态',
  rocket7: '发票',
  rocket8: '使用记录',
  rocket10: '为您的账户添加余额',
  rocket11: '添加账户余额的好处',
  rocket12: '通过充值添加余额对常规用户有几个优势，未来的购买将完全免去经过钱包和网络确认的麻烦',
    rocket13: '我的钱包余额',
  rocket14: '总充值余额',
  rocket15: '使用金额',
  rocket16: '自动续订',
  rocket17: '动态住宅代理',
  rocket18: '单价',
  rocket19p: '最小提醒流量为1GB',
  rocket19l: ' GB时自动续订，（钱包会在过期前及时为您增加流量）',
  rocket20p: '最小提醒天数为1天',
  rocket20l: '天数时自动续订，（钱包会在过期前自动续订套餐）',
  rocket21: '恢复预设',
  rocket22: '请选择套餐',
  rocket23: '订阅价',
  rocket24: '预算控制',
  rocket25: '节省成本',
  rocket26: '便利',
  rocket27: '节省时间',
  rocket28: '持续访问',
  rocket29: '减少交易费用',
  rocket29: '总价',
  rocket30: '继续支付',
  rocket31: '请扫描下方二维码完成支付',
  rocket32: '二维码将于{}后过期，请尽快支付',
  rocket33: '支付完成',
  rocket34: '取消支付',
  rocket35: '订单摘要',
  rocket36: '每{}价格',
  rocket37: '总计',
  rocket38: '是否使用优惠券？',
  rocket39: '输入优惠码',
  rocket40: '余额充值',
  rocket41: '该订单未支付',
  rocket42: '生成crlientSecret',
  rocket43: '支付确认过程中出现错误',
  rocket44: '订单号',
  rocket45: '订单支付',
    rocket46: '订阅单价',
    rocket47:'优惠获取失败',
    rocket: 'Rocket钱包',
  back:'返回',
  // Rocket钱包
  addProxyAccounts: '新增',
  // 导航顶部
  balance: '余额',
  navbar2: '企业流量剩余{}天过期',
  navbar3: '个人计划流量剩余{}天过期',
  navbar4: '退出登录',
  // 导航顶部

  panel2Title1: '全球代理池，轻松访问公共数据',
  panel2TItle2En: 'IPRocket Residential Proxy pool 从严格遵守商业道德的合作伙伴处采购',
  world: '世界各国',
  panel2text1: '确保全球全面覆盖和无障碍',
  globalIP: '全球IP',
  increase: '这一数字仍在增长',
  customer: '客户',
  reliability: '可靠性和客户满意度记录良好',
  ISP: 'ISP合作伙伴',
  network: '提供广泛的网络覆盖和可靠的连接',

  panel3Title: '一体化仪表盘：简单、清晰、高效',
  panel3text: '配置您的代理，跟踪数据，自动执行订单以及执行更多操作，我们的仪表板可适应您的需求',
  panel3btn: '现在注册',

  panel4Title: '符合您的各种用例需求',
  panel4text1: '市场研究',
  panel4text2: '旅行票价汇总',
  panel4text3: '销售与电子商务',
    seo: '搜索引擎(SEO)优化',
    seo_1: '搜索引擎(SEO)',
  adProven: '广告验证',
  twitch: 'Twitch',
  facebook: 'Facebook',
  discord: 'Discord',
  instagram: 'Instagram',
  pinterest: 'Pinterest',
  amazon: 'Amazon',
  eBay: 'eBay',
  shopify: 'Shopify',
  etsy: 'Etsy',
  airbnb: 'Airbnb',
  chatGPT: 'ChatGPT',
  youtube: 'Youtube',
  tiktok: 'Tiktok',
  reddit: 'Reddit',
  walmart: 'Walmart',
  vinted: 'Vinted',
  mercari: 'Mercari',
  airbhb: 'Airbnb',
  panel4text16: '所有用例 →',

  panel5Title: '热门的住宅代理地点',
  america: '美国',
  france: '法国',
  england: '英国',
  HongKong: '香港',
  germany: '德国',
  vietnam: '越南',
  japan: '日本',
  canada: '加拿大',
  brazil: '巴西',
  Philippines: '菲律宾',
  australia: '澳大利亚',
  panel5text11: '查看所有',

  panel6Title: '选择您的计划',
  panel6text1: '支持HTTP(s)和Socks5代理服务器',
  panel6text2: '流量计划',
    panel6text3: '企业计划',
    panel6text4:'个人流量明细',
    promotionalPrice: '活动价',
    originalPrice:'原价',
  starter: 'Starter',
  requisite: 'Essential',
  template: 'Standard',
  add: 'Plus',
  high: 'Premium',
  day: '天',
  hour: '时',
  minute: '分',
  second: '秒',
  
  allSession: '无限并发会话',
  SuccessRate: '成功率',
  buy: '立即购买',
  allocation: '可分配流量',
  countryAndCity: '国家和城市级别定位',
  session: '轮换和粘性会话',
  allWeather: '全天候技术支持',

  panel7Title: '最近评论客户反馈',

  panel8Title: '常见问题',

  EmailSupport: '邮箱帮助',
  footerTitle: '使用IPRocket拓展您的业务！',
  footerBtnLeft: '注册',
  footerBtnRight: '联系销售',
  footerText1: '关注我们',
  footerText2: '保持联系',
  address: '地点',
  company: '公司',
  allAddress: '所有地区',
  house: '动态住宅代理',
  houseText: '6000 多万真实 IP，支持http(s)和Socks协议',
  housePrice: '动态住宅代理价格',
  housePrice2: '高级动态住宅代理价格',
  blog: '博客',
  integrate: '集成',
  quickStartGuide: '快速入门指南',
  quickStart: '快速入门',
  helpCenter: '帮助中心',
  questions: '常用问题',
  partner: '合作伙伴',
  aboutUs: '关于我们',
  contactUs: '联系我们',
  nowBuy: '现在购买',
  plan: '推荐计划',
  terms: '运输条款',
  Policy: '退款政策',
  copyright: '©版权所有2024 IPRocket有限公司 | 版权所有',
  privacy: '隐私政策',
  service: '服务条款',

  priceText: '低至',
  priceDoller: ' $0.9/GB ',
  priceDoller2: ' $0.7/GB ',
  shoesAndTickets: '运动鞋与门票',
  dataCapture: '数据抓取',
  emailProtection: '电子邮件保护',
  mediaMarketing: '社交媒体营销',
  industry: '行业',
  socialMedia: '社交媒体',
  onlineRetailers: '电商',
  login: '登录',
  register: '注册',
  email: 'support@bunnyproxy.com',
  watchPrice: '价格监控',
  whyareyouIPScoket: '为什么你应该使用IPRocket的住宅代理？',
  IPStitle1: '超大规模的住宅ip代理池',
  IPScontent1: '从市场上超大的 60M+IP池中以合乎道德的方式获取 A+ 级模型代理。',
  IPStitle2: '可靠的网络',
  IPScontent2: '最可靠的基础设施，正常运行时间达 99.05%，并有专利解决方案支持。',
  IPStitle3: '最快的响应时间',
  IPScontent3: '市场领先的 0.3 秒响应时间，使数据收集无中断。',
  IPStitle4: '专用住宅代理',
  IPScontent4: '无需共享，无需拼接——您的专用代理仅在您使用时可用。',
  IPStitle5: '即时 IP 更改',
  IPScontent5: '只需单击/点击或通过 API 请求即可通过仪表板获取新 IP。立即使用池中的新代理更改您的住宅代理。',
  IPStitle6: '无障碍设施',
  IPScontent6: '只要合法，您可以使用代理访问任何您想要的网站。',
  securityTrust: '值得信赖且安全的代理网络',
  langNetwork: '无带宽限制',
  productText:
    '使用IPRocket的住宅代理避免抓取时受阻并轻松收集数据。利用全球 210多个国家和地区的6000多万个真实 IP 地址。选择任何位置、设备和浏览器即可连接到互联网',
  houseNetworkTitle: '最可靠的住宅代理网',
  houseNetworkText:
    '使用来自6000多万个 IP 池的轮换住宅代理为您的网页抓取项目提供支持。住宅 IP 地址覆盖全球，您可以轻松克服地理位置限制。',
  houseNetworkTitle2: '多样的网络类型',
  houseNetworkTitle3: '轮换和粘性会话',
  houseNetworkText2: '在 HTTP、完全加密的 HTTPS  或快速可靠的 Socks5 协议之 间进行选择。',
  houseNetworkText3: '用户可自定义旋转和粘性会话。 粘性会话最长可持续120分钟',
  houseAgentTitle: '高性能且安全的住宅代理',
  houseAgentText:
    'IPRocket的轮转住宅代理专为高性能和安全性而构建，所有连接都是安全且加密的，以保护用户数据和活动。我们提供全天候技术支持，以便用户可以在需要时获得帮助，确保服务不间断。',
  panelH1title: '价格监控用例',
  panelH2title1: '实时价格监控',
  panelH2title2: '数据驱动决策',
  panelH2title3: '获取基于地理位置的价格',
  panelText1:
    '在当今电子商务市场中，随着竞争的加剧和消费者需求的多样化，在线零售商面临着日益复杂和快速变化的环境。每天进行数千次的价格调整已经成为常态，而手动监控这种变化显然是不可能的。因此，电子商务专家们越来越依赖于先进的网络智能解决方案，如利用IPRocket代理，来进行自动实时数据传输和价格监控，以保持市场竞争力和提升运营效率。',
  panelText2:
    'IPRocket代理为在线零售商提供了实时价格监控的解决方案。能够自动捕捉并分析竞争对手的价格调整，帮助企业快速做出反应并保持市场竞争优势。企业可以通过实时数据传输和处理，及时调整定价策略，以确保在激烈的价格竞争中保持合理和有竞争力的定价水平。',
  panelText3:
    'IPRocket代理帮助企业智能地管理和运营其电子商务业务。通过整合和分析各种公开数据源，如竞争对手的价格信息和市场趋势分析，企业能够制定更加精准和有效的市场战略。这种数据驱动的决策方式不仅提升了企业的决策效率，还增强了其市场敏捷性和适应能力，在竞争激烈的电子商务市场中立于不败之地。',
  panelText4:
    '不同网站的定价信息各不相同，而且可能受地理位置影响——即使是同一家供应商也可能根据国家或货币改变价格。因此，从特定位置检索所需数据可能很困难。IPRocket 代理网络覆盖世界上超过210多个国家和地区，并提供城市级定位，让公司可以从任何地方访问定价数据。',
  panelComponenttip1: '无并发会话限制',
  marketH1: '市场研究用例',
  marketText1:
    'IPRocket 提供的6000多万个住宅代理，为企业在竞争激烈的市场中获取竞争情报提供了强大的工具。通过多样化的IP来源和地理位置选择，企业能够轻松跟踪竞争对手的活动，不仅避免了被封禁或遇到验证码的问题，还能够准确把握市场动态并制定响应性强的市场营销策略。企业在选择市场情报工具时，应考虑IPRocket提供的高效解决方案，以帮助其在竞争激烈的环境中保持竞争优势。',
  marketH2Title1: '大规模市场调研与统计',
  marketH2Title2: '市场竞争对手分析',
  marketH2Title3: '消费者偏好分析',
  marketText2:
    'IPRocket 在评估潜在的新市场时，提供了多种有益的功能。首先，通过其全球住宅 IP 网络，用户能够获得准确的当地市场数据。例如，可以访问特定国家或地区的网站，获取实时的销售数据、消费者行为模式以及市场趋势。这种数据的准确性和及时性，远远超过了传统的采样方法，因为它直接从真实消费者那里收集而来，避免了样本失真的风险。',
  marketText3:
    '您可通过IPRocket监测竞争对手在全球各地的活动，包括他们的广告策略、定价策略以及产品推广方式，可以深入了解竞争格局和市场份额的分布情况。这种深入分析为企业制定战略决策提供了重要的数据支持，有助于在新市场中获得竞争优势。',
  marketText4:
    '通过分析不同地理位置的消费者行为和偏好，企业可以更好地了解如何调整产品或服务，以适应当地市场的需求。例如，可以根使用IPRocket代理所得到的数据调整市场定位、产品功能设计或者营销策略，从而提高市场进入的成功率。',
  AdvertisementH1: '广告验证用例',
  AdvertisementH2title2: '收集相关广告信息',
  AdvertisementH2title3: '避免浪费广告预算',
  AdvertisementH2title4: '避免浪费广告预算',
  AdvertisementText1:
    '在当今数字化营销时代，利用来自世界各地的真实住宅IP地址进行广告优化已成为企业提升广告效果、优化策略的重要手段。住宅IP代理不仅能够规避复杂的机器人检测，还能提供真实用户的视角，深入分析广告在不同地区、人口统计数据和设备上的表现，为广告主提供宝贵的优化数据。',
  AdvertisementText2:
    '住宅IP代理的主要优势在于其能够模拟真实用户环境，确保广告在实际浏览器中展示，并且获得真实的点击和转化数据。这种方法使广告主能够准确评估广告效果，了解广告在不同地理位置、人口统计和设备类型下的表现差异，从而有针对性地优化广告策略。',
  AdvertisementText3:
    'IPRocket的住宅代理还能够及时识别和应对可疑活动，如点击机器人操纵，保护广告预算免受浪费和欺诈行为的影响。通过分析从同一IP地址发起的快速点击等异常行为，住宅IP代理帮助广告主快速响应并调整策略，确保广告投放的有效性和可持续性。',
  AdvertisementText4:
    '广告主应充分利用住宅IP代理的技术优势，深入分析广告效果，优化广告投放，从而实现更精准、有效的市场营销目标。随着数字广告环境的不断发展和复杂化，住宅IP代理将继续成为提升广告ROI和保护投放安全的重要工具。',
  EngineH1: '搜索引擎（SEO）优化用例',
  EngineH2Title2: 'SEO和SERP代理的可靠性',
  EngineH2Title3: '低成本的SEO和SERP代理',
  EngineH2Title4: '丰富的IP池',
  EngineText1:
    '在当今数字化时代，搜索引擎优化已经成为企业和个人网站提升在线可见性和流量的关键策略之一。然而，许多网站面临的一个普遍问题是，搜索引擎对IP地址的访问限制和封锁，导致网站难以被有效地爬取和索引。为了应对这一挑战，使用住宅代理IP成为了一种常见且有效的解决方案。',
  EngineText2:
    'IPRocket轮转型SEO及SERP代理以其高度的可靠性著称。企业在数据收集中需要稳定和连续的服务，这样才能确保数据的完整性和准确性。我们的代理服务通过先进的技术和稳定的基础设施，确保了代理的高可用性和低故障率。无论是短期项目还是长期监控，我们的服务都能提供一致的性能，满足企业的各种需求。',
  EngineText3:
    '传统的数据收集方法往往需要高昂的投入和复杂的维护，而我们的轮换型代理服务则大大降低了这些成本。通过优化资源配置和高效的运营模式，我们能够为客户提供具有竞争力的价格，使企业可以以更低的预算获取高质量的数据支持，从而提升整体的经济效益。我们的住宅IP价格低至＄0.9/GB起。',
  EngineText4:
    'IP地址丰富度是我们服务的另一大亮点。在数据收集过程中，使用多个IP地址可以有效避免搜索引擎的封锁和限制。我们的代理池中拥有海量的IP地址，且这些地址分布广泛，涵盖了全球各个地区。这样的IP多样性不仅提高了数据收集的成功率，还保证了数据的广泛性和代表性，使企业能够获得更全面和准确的市场情报。',
  DataH1: '数据抓取用例',
  DataH2Title2: '轻松实现大规模网页抓取',
  DataH2Title3: 'IPRocket如何帮您实现数据抓取？',
  DataH2Title4: '数据抓取的适用范围',
  DataText1:
    '数据抓取在今天的个人和专业应用中扮演着至关重要的角色。无论是为了市场研究、竞争情报还是业务发展，代理服务是确保数据安全和访问自由的关键工具。IPRocket提供多种高效的住宅代理选择，配合先进的地理定位技术，让用户能够轻松获取全球范围内的精准数据，不受地理限制的影响。无论您的数据需求是国家级还是城市级，IPRocket优秀的住宅代理服务都能够显著提高数据抓取的效率和成功率。',
  DataText2:
    'IPRocket 提供的解决方案为企业提供了高效的数据抓取工具，能够轻松获取数千页的数据。通过其先进的技术和强大的网络架构，IPRocket 不仅确保数据的高效率获取，还保证数据的质量和准确性。这种能力使企业能够最大化利用大数据的潜力，从而更好地理解市场环境、优化运营策略并实现业务增长。',
  DataText3:
    '我们的网络池提供了来自真实家庭设备的住宅IP地址，每个网络都可以用来抓取代理。这些住宅代理极少触发人机验证（CAPTCHA），因此非常适合有效的网络抓取。我们的网络涵盖超过210个国家和地区，拥有数钱万个IP地址，能够帮助您轻松地突破地理限制，自由访问各种内容。此外，我们的住宅代理还能显著降低封禁和重复率的风险。',
  DataText4:
    '包括但不限于：商业市场分析、社交媒体挖掘、电子商务数据分析、科学研究和学术数据收集、新闻和媒体监测、金融市场分析、医疗健康数据收集与分析等。',
  TravelH1: '旅行票价汇总用例',
  TravelH2Title2: '与传统旅游票价抓取的区别',
  TravelH2Title3: 'IPRocket代理在旅游票价汇总的优势',
  TravelH2Title4: '像专业人士一样比较价格',
  TravelText1:
    '为了提高旅行票价抓取的成功率和速度，以及避免航空公司、铁路公司和旅行社封锁IP的问题，IPRocket的住宅代理提供了一个有效的解决方案。在今天的数字化时代，访问任何航空公司网站或其他旅行服务提供商，无论是在桌面还是移动设备上，都需要确保使用真实的住宅IP地址，以避免访问限制和数据片段化的问题。',
  TravelText2:
    '传统的旅游票价抓取工具可能受到IP封锁和访问限制的困扰，这限制了数据采集的准确性和实时性。然而，通过IPRocket的住宅代理服务，用户可以轻松地模拟真实用户的访问行为，从而不受阻碍地访问任何航空公司、铁路公司或旅行社的网站。这种服务利用了庞大的住宅IP代理池，确保用户可以发送无限并发连接请求，将抓取工具的效率提升到全新的水平。',
  TravelText3:
    '首先，他们可以避免因IP封锁而导致的访问限制，确保能够实时获取航班票价和座位信息。其次，可以提高抓取工具的成功率和速度，因为真实的住宅IP地址使得数据采集更为稳定和可靠。最重要的是，这种服务为用户提供了一个合法且有效的方式，帮助他们有效竞争市场和提升服务质量。',
  TravelText4:
    '网站通常会根据您的位置显示不同的价格。住宅代理可让您到不同的国家/地区的网站，显示本地 IP 无法看到的价格，从而获取航空公司和酒店不想让您知道的优惠。IPRocket借助庞大的住宅代理池解决了旅游和酒店业面临的地理限制问题，为企业提供了全球数据采集和分析的有效解决方案。',
  MotionH1: '运动鞋与门票用例',
  MotionH2Title2: 'IPRocket为什么可以成为您的运动鞋代理？',
  MotionH2Title3: 'IPRocket将全程保护您安全购买',
  MotionH2Title4: '全球地区的限量球鞋/门票抢购',
  MotionText1:
    '在当前的在线零售市场上，限量版运动鞋及演出门票因其供应量稀少而需求旺盛，常常在发布后仅几秒钟内即被抢购一空。对于热衷于运动鞋或演出的消费者而言，获取这些独特鞋款或稀缺演出门票的机会成为一场技术与速度的竞争，而高质量IP代理则成为他们的利器。',
  MotionText2:
    '我们的IP代理专门设计用于优化购买体验。通过连接到距离目标服务器最近的代理服务器，消费者能够极大地减少订购过程中的响应时间和网络延迟。在限量版运动鞋发售时，每一秒都能够影响到是否能够成功下单。因此，运动鞋IP代理的快速响应能力使得消费者能够在最短的时间内获取到最新的库存信息，并尽可能快速地完成购买流程，增加成功购买的机会',
  MotionText3:
    '在进行在线购买时，消费者的个人信息和支付信息需要得到有效的保护，以免遭受网络攻击或信息泄露的风险。通过使用代理，消费者可以隐藏其真实的IP地址和地理位置，减少被追踪或攻击的风险，从而更安全地进行购物和交易。',
  MotionText4:
    '您可以根据需求选择不同地区的代理服务器，获取更多版本的限量版运动鞋或演出门票，或者参与跨地区的不同发售活动。这种灵活性不仅增加了购买成功的机会，还能够满足消费者多样化的需求和偏好，使其能够更轻松地获取心仪的运动鞋款式或演出门票。',
  SaleH1: '销售与电子商务用例',
  SaleH2Title2: '用于竞争分析的住宅代理',
  SaleH2Title3: '保护自己的品牌',
  SaleH2Title4: '探索新的销售群体和销售渠道',
  SaleText1:
    '在当今全球化和数字化的时代，企业面临着越来越复杂和激烈的竞争环境。IPRocket 网络代理作为一种强大的工具，为企业提供了独特的能力，使它们能够更好地管理和适应这种挑战性环境。',
  SaleText2:
    'IPRocket 网络代理允许企业进行全面的市场分析和竞争对手的监测。企业可以实时地收集和分析市场数据，了解竞争对手的定价策略、产品特性以及市场份额的变化趋势。这种全面的分析不仅帮助企业更好地定位自己在市场中的位置，还能够发现市场机会和潜在的威胁。',
  SaleText3:
    '通过使用IPRocket代理服务器，企业可以保护自己的品牌免受恶意攻击和竞争对手的侵害。这种保护不仅限于网络安全，还包括在市场营销和品牌管理方面的保护。例如，企业可以利用代理服务器来欺骗竞争对手，防止其获取关键信息或者通过恶意手段损害企业的声誉和品牌价值。',
  SaleText4:
    'IPRocket 网络代理的使用不仅仅是应对竞争的手段，更是推动企业创新和发展的重要工具。企业可以实现全球网络资源的高效利用，拓展市场边界，探索新的客户群体和销售渠道，从而实现持续增长和发展。',
  EmailH1: '电子邮件保护用例',
  EmailH2Title2: '保障电子邮件安全',
  EmailH2Title3: '发现潜在风险和威胁',
  EmailH2Title4: '保持匿名与安全',
  EmailText1:
    '在今天的数字化时代，电子邮件已经成为组织和个人重要的沟通工具。然而，随之而来的是电子邮件安全的威胁，例如恶意软件和数据泄露，这些威胁可能导致严重的信息安全问题。为了有效保护敏感的电子邮件通信，并帮助组织避免网络攻击，网络安全公司依赖于高质量的IP代理来扫描来自不同IP地址的电子邮件。',
  EmailText2:
    'IPRocket等可靠的IP代理提供商在电子邮件安全中扮演着关键角色。它们通过提供几乎100%正常运行时间的稳定服务，确保网络安全公司能够全天候进行电子邮件扫描，及时发现潜在的安全威胁。这些代理不仅提供匿名性，还能有效地隐藏扫描者的真实身份，防止被攻击者意识到其扫描活动。',
  EmailText3:
    '网络安全公司利用IP代理扫描电子邮件，以识别可能存在的风险和威胁。这包括检测可能的数据泄密、恶意附件、以及其他潜在的安全漏洞。通过从不同IP地址发送和接收电子邮件，他们能够模拟多样化的网络环境，更全面地评估电子邮件内容的安全性。',
  EmailText4:
    '为了成功扫描电子邮件，保持匿名和不被发现至关重要。IPRocket代理通过隐藏真实IP地址，确保网络安全公司的扫描活动不会被攻击者察觉。这种匿名性不仅保护了扫描者的身份安全，还确保了扫描活动的效果和有效性，从而更好地保护电子邮件的安全和机密性。',
  MarketingH1: '社交媒体营销用例',
  MarketingH2Title2: '内容推广和影响力营销',
  MarketingH2Title3: '社交媒体营销和市场研究',
  MarketingH2Title4: '建立您品牌的良好声誉',
  MarketingText1:
    '为了掌控在社交媒体领域的利基市场，智能营销活动通过制定预测未来趋势的策略变得至关重要。在当今数字化时代，社交媒体平台已经成为企业与消费者之间沟通和互动的重要桥梁。通过使用IPRocket代理进行自动和常规数据收集系统，企业可以轻松地从各大社交媒体平台收集到最新和真实的数据。',
  MarketingText2:
    '营销活动通过数据驱动的方法帮助企业精准地接触和影响目标受众。通过IPRocket代理收集数据，企业可以实时了解客户的行为和偏好，从而深入理解客户的旅程和当前的需求。这种深入了解客户的能力，使得企业能够以更加精准和个性化的方式进行营销活动，从而提高营销活动的效率和回报率',
  MarketingText3:
    '社交媒体营销为各种规模的企业提供了一系列好处。首先，它提供了一种经济高效的方式来接触大量受众。通过创建引人入胜且相关的内容，企业可以吸引关注者并提高品牌知名度。其次，社交媒体允许定向广告，这意味着企业可以精准地接触到理想的客户。第三，社交媒体提供了有关客户行为和偏好的宝贵见解，可以为营销策略和产品开发提供信息。',
  MarketingText4:
    '社交媒体营销活动通过创建能够引起受众深刻共鸣的内容，帮助企业在社交媒体上建立品牌声誉和用户忠诚度。这种与受众需求高度契合的内容策略，不仅增加了用户的参与度和互动性，还有助于提升品牌在社交媒体平台上的影响力和可见度。',
  otherDemoTitele: '查看其他用例',
  data: '数据抓取',
  market: '市场研究',
  Sale: '销售与电子商务',
  Motion: '运动鞋与门票',
  Travel: '旅行票价汇总',
  Engine: '搜索引擎优化',
  Price: '价格监控',
  Email: '电子邮箱保护',
  Advertisement: '广告技术',

  chartGPTH1: '最可靠的ChatGPT代理',
  chartGPTH2T2: '安全与匿名性',
  chartGPTH2T3: '自然语言处理、机器学习',
  chartGPTH2T4: '创新和竞争力提升',
  chartGPTText1:
    '为了充分释放AI对话的全部潜力，使用ChatGPT代理是至关重要的。ChatGPT作为一种先进的人工智能技术，正在彻底改变我们的在线互动方式，极大地影响我们的学习和问题解决过程。无论是深入研究人工智能的前沿，自动化客户服务的需求，还是简单地探索AI技术的可能性，IPRocket住宅代理都能够确保您能够安全、顺畅地连接到Chat GPT平台。',
  chartGPTText2:
    '在当前快速发展的科技环境中，面对诸多AI驱动项目的挑战，保证高效率并不受速度减慢或瓶颈影响至关重要。IPRocket住宅代理不仅提供高速和可靠的访问，更重要的是保障了匿名性，能够绕过任何潜在的限制，为开发人员、研究人员以及其他AI技术应用者提供了后台支持和安全通行证。',
  chartGPTText3:
    '对于开发人员而言，ChatGPT代理的使用意味着能够在不受外部限制干扰的情况下，专注于AI技术的创新和应用开发。研究人员则可以依托我们的代理，深入挖掘人工智能的各个领域，无论是自然语言处理、机器学习还是智能决策系统的开发。',
  chartGPTText4:
    '随着全球AI技术的竞争日益激烈，企业和个人需要通过更高效的AI应用来保持竞争优势。ChatGPT代理的使用不仅仅是一种技术选择，更是一种战略决策，能够帮助用户在保持创新力的同时，有效地管理和运营多个AI驱动项目。这种支持不仅仅是技术层面的，更是对组织战略发展的积极促进。',

  discordH1: '最可靠的Discord代理',
  discordH2T2: '严格的禁令系统',
  discordH2T3: '使用IPRocket代理规避禁令',
  discordH2T4: '避免遇到反机器人措施',
  discordText1:
    '随着越来越多的人选择在家工作、玩游戏和社交，这个群聊平台在过去几年中迅速赢得了大众的喜爱和广泛使用。Discord 不同于传统的社交媒体平台，它提供了一个结合实时聊天、语音和视频功能的多功能环境，使用户能够与志同道合的人群进行沟通和互动。',
  discordText2:
    '尽管 Discord 提供了丰富多彩的社交体验，但它也面临着一些挑战，尤其是在管理用户和内容方面。Discord 的 IP 禁令系统是其中一个备受争议的方面。这个系统旨在防止恶意用户、不良内容和其他违规行为，但有时也会误伤正常用户。特别是对于那些使用公共网络或特定地区网络的用户，可能会因为与其他违规用户共享相同的 IP 地址而被误判或禁止访问 Discord 平台。',
  discordText3:
    '为了绕过这些限制，许多用户选择使用 Discord 代理服务器。代理服务器通过隐藏用户的真实 IP 地址并提供代理 IP 地址的方式，帮助用户规避 IP 禁令和其他地理限制。这种技术不仅仅可以让用户继续访问和使用 Discord，还可以保护他们的隐私和安全，避免身份暴露和信息泄露的风险。',
  discordText4:
    'Discord 已采取措施防止自动机器人滥用该平台。通过使用住宅代理，您可以将机器人的请求分发到不同的 IP 地址，从而使 Discord 的反机器人系统更难检测和阻止您的机器人。IPRocket的住宅代理为您的 Discord 活动增加了一层额外的隐私和安全保障。它们有助于保护您的个人信息并降低针对性攻击或未经授权访问的风险。',

  facebookH1: '最可靠的Facebook代理',
  facebookH2T2: '增强Facebook隐私保护',
  facebookH2T3: '高效管理多个Facebook账户',
  facebookH2T4: '定制内容与特定受众互动',
  facebookText1:
    '在当今数字化社交平台盛行的时代，如何有效管理和保护个人或企业在Facebook上的多个账户，成为许多用户关注的重要问题。IPRocket住宅代理提供了一种有效的解决方案，不仅能够提升隐私保护水平，还能够帮助用户高效管理和扩展他们的社交媒体账户。',
  facebookText2:
    '使用IPRocket住宅IP代理可以有效保护用户的隐私。传统上，Facebook等社交平台对于同一IP地址下的多个账户存在风险，可能被视为违反规定而受到限制甚至封禁。通过使用住宅IP代理，用户可以轻松切换不同的IP地址，避免因IP相关问题而引发的安全风险，保护个人或企业的账户安全和隐私。',
  facebookText3:
    '对于需要管理多个Facebook账户的个人或企业而言，IPRocket住宅I代理提供了便捷和高效的解决方案。通过代理，用户可以同时登录和管理多个账户，而无需担心账户被检测到违规行为。这种灵活性不仅节省了时间和精力，还能够有效避免因账户管理不当而导致的封禁风险。',
  facebookText4:
    'IPRocket住宅代理还能帮助个人或企业定制其内容，并与特定的目标受众进行互动。通过选择不同地理位置的IP地址，用户可以定位和吸引特定地区或人群的观众，提升内容的个性化和吸引力。这种精准的定位能力不仅增强了内容的传播效果，还有助于建立和维护独特的在线身份和品牌形象。',

  instagramH1: '最可靠的Instagram代理',
  instagramH2T2: 'Instagram隐私保护与安全意识',
  instagramH2T3: '优化浏览体验与地理定位功能',
  instagramH2T4: '为什么要使用IPRocket的Instagram代理？',
  instagramText1:
    '使用社交媒体平台如Instagram时，用户需要保护个人信息免受恶意用户或网络攻击的威胁。IPRocket代理提供了一种有效的解决方案，通过隐藏真实IP地址来保护用户设备和个人信息的安全。同时, IPRocket的住宅IP资源覆盖了210多个地区，为用户提供了优化网络连接和地理定位功能的选择，从而显著提升了在Instagram上的浏览性能和使用体验。',
  instagramText2:
    '在今天的互联网环境中，个人隐私保护至关重要。特别是在使用社交媒体平台时，如何有效地保护个人信息免受网络威胁的侵害成为用户关注的焦点。IPRocket作为一种有效的代理服务工具，能够帮助用户隐藏其真实IP地址，从而有效防范可能的恶意用户或网络攻击，确保用户在使用Instagram时的安全性和隐私保护。',
  instagramText3:
    'IPRocket代理通过连接到距离Instagram服务器更近的代理服务器节点，用户可以体验到更快的加载速度和更流畅的浏览过程。此外，IPRocket的住宅IP资源涵盖了全球210多个地区，用户可以轻松选择目标城市的IP地址进行访问，实现地理定位功能。',
  instagramText4:
    'IPRocket在保护用户隐私和提升Instagram使用体验方面发挥了重要作用。通过隐藏真实IP地址和提供优化的网络连接，IPRocket有效地降低了用户面临的网络安全风险，并显著改善了在Instagram平台上的浏览效率和操作体验。未来，随着网络环境的不断演变，IPRocket将继续为用户提供安全可靠的代理服务。1',

  pinterestH1: '最可靠的Pinsterest代理',
  pinterestH2T2: '创建无限数量的 Pinterest 帐户',
  pinterestH2T3: '使用 Pinterest 机器人实现一切自动化',
  pinterestH2T4: '无限线程和连接',
  pinterestText1:
    '在使用社交媒体平台如Pinterest时，如何有效地定制内容、与特定受众互动，并保护个人或企业的在线身份，成为了用户关注的焦点。IPRocket住宅IP代理通过提供安全的网络连接和匿名浏览功能，帮助用户设置和优化Pinterest帐户，包括个人资料设置、板块创建和内容组织，提升了用户在平台上的使用体验和效果。',
  pinterestText2:
    '住宅代理通过其固有的隐藏 IP 地址功能允许无限数量的帐户。如果任何帐户收到导致被禁止的垃圾邮件报告，请不要担心，因为您可以再创建一个。此外，各种 Pinterest 自动化工具需要使用大量同步帐户才能正确高效地运行。这意味着您可以借助最佳 Pinterest 代理机构高效地管理众多帐户并成倍增加您的关注者。',
  pinterestText3:
    'Pinterest 和其他社交媒体平台不喜欢机器人或自动化软件。因此，使用代理隐藏您的 IP 地址非常重要。Pinterest 代理可以与浏览器、API、机器人和自定义软件的任意组合一起使用。IPRocket的住宅代理非常值得信赖，其通过隐藏自动化工具需要发送的请求数量来启用机器人。自动固定操作可以大大增加您作为创作者的影响力，因为人们会更频繁地注意到您的内容。',
  pinterestText4:
    '当你注册使用IPRocket 的 Pinterest 代理时，你将可以访问超过8000w全球代理IP。使用住宅代理解除 Pinterest 封锁，没有并发限制或带宽限制，为您的 Pinterest 帐户组织代理所需的一切都触手可及。',

  redditH1: '最可靠的Reddit代理',
  redditH2T2: '确保 Reddit 帐户的隐私和安全',
  redditH2T3: '避免触发速率限制',
  redditH2T4: '高效利用Reddit 投票机器人',
  redditText1:
    '在当前数字化时代，隐私保护和数据访问自由是网络用户越来越关注的问题。特别是在使用社交媒体和信息分享平台如Reddit时，如何保护个人隐私并绕过地理和API访问限制成为了用户关注的重点。IPRocket代理作为一种有效的技术工具，不仅可以保障用户在Reddit上的隐私安全，还能帮助用户克服API限制和访问受限的内容，提升用户的使用体验和数据收集效率。',
  redditText2:
    '代理网络充当您的个人互联网地址和 Reddit 之间的桥梁。IPRocket代理通过为用户提供住宅IP地址，隐藏真实的网络地址信息，有效保护了用户在使用Reddit时的隐私和安全。',
  redditText3:
    'Reddit的API具有严格的速率限制，这对于需要大量数据访问的用户而言是一个挑战。通过使用住宅代理进行IP轮换，用户可以从多个不同的IP地址访问API，从而避免触发Reddit的速率限制。每个住宅IP地址被视为一个独立的用户，这有效地提高了数据收集的效率和成功率，使得用户能够更加灵活地利用Reddit的API功能。',
  redditText4:
    'Reddit 作为当今最受欢迎的社交媒体服务之一，让人们查看和投票您的帖子可能是一个挑战。投票机器人可以为 Reddit 用户提供宝贵的帮助，您所需要的只是多个 Reddit 帐户、机器人软件和住宅代理。通过使用特定国家或城市的住宅代理，将您的 Reddit 营销重点放在相关地区。将您的机器人伪装成 Reddit 上的真实用户，以开展本地化营销活动。',

  TIKTOKH1: '最可靠的Tiktok代理',
  TIKTOKH2T2: '利用IPRocket代理帮您注册Tiktok账户',
  TIKTOKH2T3: '全球地区支持',
  TIKTOKH2T4: '稳定的网络链接代理服务',
  TIKTOKText1:
    '为了帮助商家全球化并利用TikTok这一新兴的电商平台，IPRocket代理提供了一个强大的工具。在移动时代，TikTok已经成为全球娱乐的首选平台，其创新的内容形式和广泛的用户基础使其成为了商家推广产品和服务的理想平台。IPRocket代理通过提供全球各地的IP注册服务，帮助商家轻松进入TikTok市场，扩展业务范围，接触更多全球用户，从而实现业务的蓬勃发展。',
  TIKTOKText2:
    '在如此繁荣的TikTok平台上，商家如何有效地利用其全球用户资源成为了一个关键问题。IPRocket代理提供了一种创新的解决方案，即通过其全球IP注册服务，帮助商家在世界各地注册TikTok账号和推广活动。这种服务不仅仅是简单的技术支持，更是对商家全球市场战略的重要支持。',
  TIKTOKText3:
    'IPRocket代理通过提供多地区的IP地址注册服务，使得商家可以在英国、美国、马来西亚、菲律宾、泰国、越南、新加坡等市场上线TikTok账号，从而直接接触当地用户群体。这种本地化的注册方式有助于商家避免地理限制和语言障碍，更有效地与目标市场进行沟通和互动。',
  TIKTOKText4:
    'IPRocket代理还通过优化的网络连接和稳定的代理服务，确保商家在使用TikTok平台时能够稳定运行推广活动，避免因地理位置或网络限制而导致的操作问题和延迟。这种专业的技术支持不仅提升了商家在TikTok上的用户体验，还保障了推广活动的有效性和效果。',

  twitchH1: '最可靠的Twitch代理',
  twitchH2T2: '保护Twitch账户安全和隐私',
  twitchH2T3: '全球观众的发掘和互动',
  twitchH2T4: '增强灵活性和控制力',
  twitchText1:
    'Twitch作为全球最大的游戏直播平台，吸引了数百万的观众和内容创作者。然而，随着其用户群体的扩大和平台规模的增加，安全和隐私保护变得愈发重要。使用Twitch代理成为许多用户的首选，不仅可以确保流媒体传输的稳定性和安全性，还能有效规避一些潜在的风险和限制。',
  twitchText2:
    'Twitch平台对于账户的安全措施非常严格，任何违反规定的行为都可能导致账户被封禁或受到其他制裁。使用Twitch代理可以帮助用户隐藏真实IP地址，减少因IP相关问题而遭受的风险，保护账户的安全性和隐私。',
  twitchText3:
    '利用Twitch代理，用户可以轻松访问全球各地的Twitch频道，拓展观众的地域覆盖范围。这种全球化的观众互动不仅能增加观众数量，还能够为内容创作者提供更多元化的观众反馈和互动机会，使直播内容更具吸引力和互动性。',
  twitchText4:
    '对于Twitch主播和内容制作者来说，代理提供了更大的灵活性和控制力。他们可以通过代理选择特定地区的服务器，优化直播流的质量和稳定性，同时在全球范围内管理和扩展自己的观众群体。这种能力不仅提升了直播的专业性，还能使内容更贴近观众的需求和偏好。',

  youtubeH1: '最可靠的Youtube代理',
  youtubeH2T2: '隐私保护与匿名访问',
  youtubeH2T3: '绕过IP访问限制',
  youtubeH2T4: '反机器人措施',
  youtubeText1:
    '是在使用广泛的社交媒体平台如Youtube时。住宅代理通过替换您的真实IP地址为住宅位置的IP地址，为用户提供了重要的隐私保护功能。除此之外，它还可以用于管理多个Youtube帐户，绕过基于IP的访问限制，并应对平台的反机器人措施，为用户带来更安全、更灵活的使用体验。',
  youtubeText2:
    '使用社交媒体视频平台如Youtube时，用户的个人信息和浏览行为可能受到跟踪和收集，因此保护个人身份和隐私显得尤为重要。IPRocket的住宅代理作为一种技术解决方案，能够有效替换用户的真实IP地址，隐藏其真实位置信息，从而保护用户在使用Youtube时的隐私和匿名性。',
  youtubeText3:
    '在某些情况下，用户可能因为地理位置或其他因素而受到Youtube的访问限制，如服务器访问限制或速率限制。IPRocket的住宅代理通过提供来自不同住宅位置的IP地址，使用户能够绕过这些限制，自由访问他们想要的内容或功能，提升了用户在平台上的灵活性和便利性。',
  youtubeText4:
    'Youtube作为全球领先的视频分享平台，也面临着机器人滥用的挑战。为应对这一问题，Youtube采取了多种反机器人措施，包括检测并封锁不正当的机器人行为。IPRocket的住宅代理能够将机器人请求分发到不同的IP地址，使得Youtube的反机器人系统更难检测和阻止用户的机器人操作，从而保护用户合法的使用权益。',

  airbnbH1: '最可靠的Airbnb代理',
  airbnbH2T2: '获取更多房源',
  airbnbH2T3: '避免遇到机器人验证',
  airbnbH2T4: '为您的业务带来竞争优势',
  airbnbText1:
    'Airbnb 的全称是“空中民宿”，是一个在线市场，业主可以在此将房屋短租给旅行者。Airbnb 实际上并没有任何房产，只是充当业主和租客之间的中间人。旅行者可以找到并租用适合多人入住的私人房间，甚至可以租用整个房屋。',
  airbnbText2:
    'Airbnb 已成为酒店业的热门替代品，其日益流行的趋势带来了更多的房源，从而为用户提供了更多的选择。事实上，目前 Airbnb 上有超过 600 万个房源。这是大量有价值的房产列表数据，人们可以将其用于各种目的，因此如果您想提取所有这些数据，那么您需要使用IPRocket住宅代理来抓取。',
  airbnbText3:
    'Airbnb 代理将为您处理所有数据流量，从而隐藏您访问的任何网站或使用的任何应用程序的 IP 地址，并且它们只能看到代理服务器的 IP 地址。通过不断轮换这些 IP 并使用最佳的 Airbnb 代理（即住宅代理），您的抓取机器人每次发送请求时都会拥有不同的 IP 地址，并有效地欺骗任何网站，使其认为您的机器人的请求来自真正的用户。',
  airbnbText4:
    '随着数据在当今商业决策中的重要性不断增加，合理和有效地利用Airbnb代理网络成为了许多企业和个人的必然选择。通过这些技术手段，用户可以更加智能地进行市场竞争分析、房地产投资决策和服务优化，为自己的业务带来持续的竞争优势和发展机会。',

  amazonH1: '最可靠的Amazon代理',
  amazonH2T2: '抓取产品定价',
  amazonH2T3: '监控竞争对手',
  amazonH2T4: '获取各个品牌的评论和反馈',
  amazonText1:
    '为了在竞争激烈的市场中获取竞争优势，使用IPRocket住宅代理抓取亚马逊上最热门的数据是一项关键策略。IPRocket住宅代理提供了稳定和高效的数据抓取服务，能够帮助用户深入了解不同市场的定价策略、监控竞争对手的产品动态，收集客户评价，并及时了解最新的市场趋势。',
  amazonText2:
    '通过使用IPRocket住宅代理，用户可以实时抓取和分析各个市场的定价信息。这包括了不同地区和国家的定价差异，帮助用户制定精确的定价策略以在不同市场中保持竞争力。例如，通过比较不同市场的同类产品定价，用户可以确定在某些市场降价促销或者提价的最佳时机，从而优化产品的定价策略，提高销售效率和市场占有率。',
  amazonText3:
    '除了定价策略外，监控竞争对手的产品是另一个关键点。IPRocket住宅代理能够实时抓取竞争对手的产品列表、特性和库存情况。通过分析这些数据，用户可以了解竞争对手的产品优势和市场定位，及时调整自己的产品组合和营销策略，以增强竞争力并抢占市场份额。',
  amazonText4:
    'IPRocket代理还能够获取Amazon市场上各个品牌的客户评论和反馈，帮助用户了解最新的市场趋势和消费者偏好。通过分析这些数据，用户可以更准确地把握市场动向，及时调整产品推广和营销策略，提高市场反应速度和产品的销售效率。',

  ebeyH1: '最可靠的eBay代理',
  ebeyH2T2: '从eBay获得高收益的简单方法',
  ebeyH2T3: '让多个账号辅助您竞标',
  ebeyH2T4: '避免触发eBay保护机制',
  ebeyText1:
    'eBay是互联网上最大的拍卖网站之一。eBay成立于 1995年，目前每天处理数百万次拍卖。为了充分利用 eBay，用户需要有钢铁般的意志和快速的反应能力，以最低的价格抢购最佳商品。为了获得最佳的eBay 体验，eBay代理可以自动执行许多日常竞价任务，让您物有所值。我们将重点介绍使用eBay代理的诸多好处以及如何找到最佳选择。',
  ebeyText2:
    '在 eBay 上寻找超值优惠可能是一种冒险。由于每分钟都有大量商品上线，因此跟踪热门新优惠很容易变成一份全职工作。此外，当您参与一场高能量拍卖时，每一毫秒的浪费都可能错失良机。拍卖狙击手可以在最后一刻迅速出击并赢得物品。除了整天坐在办公桌前，没有社交生活，有没有办法确保您赢得拍卖？有！通过使用高质量的代理，您就可以轻轻松松地拍到心仪的拍卖品。',
  ebeyText3:
    'eBay代理人的另一个好处是能够创建多个账号。eBay通常只允许用户一个账号，但是借助可靠的代理，您就可以创建多个账号供机器人使用。每个账号都是唯一的，因为代理会隐藏您的IP地址。有了多个账号，您就可以同时对几个拍卖品进行出价，并通过出价来增加您拍卖的成功率。如果您试图在没有代理的情况下做这些事情，您可能很快就会被封号。',
  ebeyText4:
    '在 eBay 上搜索最优惠的交易时，当前价格信息至关重要。由于在疯狂的拍卖期间价格会以闪电般的速度变化，任何数据延迟都可能造成灾难性的后果。幸运的是，代理可以帮助收集准确的定价信息。如果 eBay 检测到请求激增，可能会触发安全响应。为了避免在收集数据时被禁止，可靠、安全的代理是必不可少的，以确保您的 IP 地址和主机受到保护。',

  etsyH1: '最可靠的Etsy代理',
  etsyH2T2: '确定最畅销产品',
  etsyH2T3: '收集评论以观察消费者情绪',
  etsyH2T4: '优化您的定价、供应链和营销策略',
  etsyText1:
    '在当今竞争激烈的电商市场中，了解和比较竞争对手的产品定价和库存情况是保持竞争优势的关键策略。特别是在Etsy这样的创意市场平台上，使用IPRocket住宅代理定期分析市场趋势和消费者行为可以帮助卖家优化产品策略，提高销售效率和市场份额。',
  etsyText2:
    '为了保持竞争优势，了解和推广Etsy上的最畅销产品至关重要。通过IPRocket住宅代理抓取数据，可以获取当前流行的礼品和产品数据，分析其销售趋势和消费者喜好。尤其是在节假日和特殊类别的促销期间，及时收集并分析这些数据可以帮助用户抓住市场机会，提升销售额和品牌曝光度。',
  etsyText3:
    '消费者的情绪和反馈对产品销售有着直接的影响。通过抓取Etsy平台上的产品评论和评价，可以深入了解消费者对产品的态度和满意度。这些数据不仅可以帮助用户优化产品设计和品质，还能够调整营销策略，提升客户体验和忠诚度。',
  etsyText4:
    '通过综合分析竞争对手的定价策略和产品特点，用户可以优化自己的定价、供应链和营销策略。例如，通过发现竞争对手的产品匹配和市场研究，可以更好地把握市场趋势、需求变化和客户行为，从而发现和开发新的畅销产品，提升市场竞争力和盈利能力。',

  mercariH1: '最可靠的mercari代理',
  mercariH2T2: '为什么要使用mercari代理？',
  mercariH2T3: '开设多个macari账户',
  mercariH2T4: '选择一个靠谱的代理服务商',
  mercariText1:
    'Mercari是一家总部位于日本的在线购物平台，成立于2013年。作为一家以C2C（消费者对消费者）交易为主的电子商务平台，Mercari致力于提供一个简单易用的市场，让用户可以买卖各种类型的商品，包括服装、家居用品、电子产品等。',
  mercariText2:
    'IPRocket的住宅代理通过将用户的网络请求路由到合法住宅IP地址，来掩盖其真实IP地址。在电子商务中，这种代理尤为重要，因为它可以帮助卖家规避平台的限制，例如IP封锁或地理限制。这意味着卖家可以更自由地访问Mercari平台，并利用全球不同地区的市场机会。',
  mercariText3:
    '如果您将mercari用于营销目的，则开设和运行多个mercari帐户可以帮助您接触到更多的受众并吸引更多的关注者。但是，mercari不允许用户拥有多个帐户，因此如果您开设多个帐户，mercari服务器会检测并阻止您。为了防止这种情况发生，您可以使用IPRocket住宅代理，我们将为每个帐户提供不同的 IP 地址。这样，您的每个帐户看起来都来自不同的用户和位置，从而避免mercari禁令。',
  mercariText4:
    '实施住宅代理的有效方法包括选择可靠的服务提供商，确保代理IP的稳定性和安全性。这些代理不仅可以帮助卖家维持在线匿名性，还能提供额外的安全保障，保护个人和财务信息免受网络攻击。IPRocket住宅代理拥有超过6000万ip池，覆盖全球超过210个国家，连接成功率99.05%，绝对是您的不二选择。',

  shopifyH1: '最可靠的Shopify代理',
  shopifyH2T2: '为什么大多数Shopify自动结账机器人会失败？',
  shopifyH2T3: '不受限制地抓取 Shopify数据',
  shopifyH2T4: 'Shopify 的最佳代理是什么？',
  shopifyText1:
    '在当今快速发展的电商环境中，使用自动结账机器人在Shopify平台上进行购买是一种吸引人的策略。然而，尽管使用良好的代理技术，大多数自动结账机器人仍然面临失败的风险。这主要是因为Shopify在阻止机器人和代理方面做得非常出色，采取了多层次的安全措施以保护其市场环境的公平性和合法性，使用IPRocket住宅代理可以避免这种情况发生。',
  shopifyText2:
    'Shopify 在检测自动结账机器人方面做得非常好。由于 Shopify 为如此多的在线电子商务市场提供支持，因此它面临着阻止机器人和代理的巨大压力。这就是为什么在大多数情况下您无法使用数据中心代理购买多件商品的原因 - 它们将被批量阻止。',
  shopifyText3:
    '使用IPRocket无限并发的代理连接来抓取 Shopify 价格、产品描述和任何其他数据。通过我们的优质住宅 Shopify 代理网络获取高速、高成功率和准确的本地信息。按需访问特定国家/地区的 IP，永远不会再被阻止。',
  shopifyText4:
    '住宅代理是 Shopify 的最佳代理。它能代替真正的台式机或移动设备。Shopify 擅长检测机器人，因此您需要最真实的 IP 地址和具有独特指纹的最佳软件才能成功复制。',

  vintedH1: '最可靠的vinted代理',
  vintedH2T2: '为什么需要vinted代理？',
  vintedH2T3: '数据加密及访问控制',
  vintedH2T4: '改善您在Vinted上的购物或销售体验',
  vintedText1:
    'Vinted可在 Android、iOS 和桌面浏览器上使用，允许用户购买、出售或交换二手或全新服饰及配件。这款来自立陶宛的应用程序目前已在15个国家和地区上线，拥有超过4500万注册用户。卖家青睐这个平台，因为它不收取任何费用，而买家也喜欢它，因为他们能够以实惠的价格找到独特的商品。然而，由于各种原因，Vinted可能会封禁用户账户。此外，使用借记卡或信用卡进行在线购物始终存在一定风险。因此，使用Vinted代理服务是一个明智的选择。',
  vintedText2:
    '代理服务器在Vinted上的作用是通过隐藏用户的真实IP地址，保护用户的隐私并增加账户的安全性。它们充当中间人，转发用户与Vinted服务器之间的数据交流。使用代理服务器可以避免Vinted检测到异常的活动，比如过度的数据抓取或频繁的登录操作，从而降低账户被封禁的风险。',
  vintedText3:
    '代理服务器会为用户分配一个临时的IP地址，使Vinted无法识别用户的真实身份和位置。代理通常会对数据进行加密处理，确保用户在数据传输过程中的隐私和安全性。代理服务器还能够控制和管理用户的访问权限，以提高账户的安全性和稳定性。',
  vintedText4:
    '通过轮换IP地址和模拟真实用户的访问行为，代理服务器可以帮助用户避免因为过度活动而被Vinted封禁账户。使用代理服务器进行数据抓取和分析可以大幅提高效率，快速获取所需信息并做出相应的决策。通过选择特定国家或地区的IP地址，用户可以模拟不同地理位置的访问，从而了解不同市场的需求和价格趋势。',

  walmartH1: '最可靠的Walmart代理',
  walmartH2T2: '为什么需要沃尔玛代理？',
  walmartH2T3: '什么是购物机器人？',
  walmartH2T4: '使用代理安全访问沃尔玛',
  walmartText1:
    '近年来，我们看到一些大牌商店将注意力转向线上空间，而其他一些商店甚至关闭了实体店。这一现象表明商业领域正在发生转变，线上商店的利润越来越高，实体店逐渐被淘汰。沃尔玛等实体店意识到了网上购物行业的优势。该公司决定加入这一潮流，为用户设计和提供网上商店。让我们来看看沃尔玛网上商店是如何运作的，以及为什么您可能需要代理才能有效地使用它。',
  walmartText2:
    '当您在自动化解决方案中使用代理服务器时，一系列机器人请求将被分配不同的 IP 地址，使得每个请求看起来都来自不同位置的不同设备。这一简单功能使您的流量与其他常规访问者无法区分，使您免于检测，并且您可以继续在平台上进行零售装瓶而不会出现任何问题。',
  walmartText3:
    '购物机器人是指使用自动化软件在网上商店购买产品的过程。在这种情况下使用的主要工具是购物机器人。它们会搜索购物网站并加快结账流程，让用户可以在一瞬间购买到热门产品。这些机器人非常高效，对于希望利用限量版销售和折扣的个人来说非常有用。',
  walmartText4:
    '购物机器人是一种自动完成结账流程的软件解决方案。不幸的是，使用非人类流量的自动化在沃尔玛网站上是被禁止的。不同的购物平台都有监控可疑请求的机制，并在出现任何恶意活动时发布 IP 禁令。因此，避免此类禁令的唯一方法是对一系列请求使用不同的 IP 地址，这时IPRocket的住宅代理就派上用场了。',

  franceIPTitle: '法国ip数量',
  americaIPTitle: '美国ip数量',
  britainIPTitle: '英国ip数量',
  hongkongIPTitle: '香港ip数量',
  philippinesIPTitle: '菲律宾ip数量',
  canadaIPTitle: '加拿大ip数量',
  germanyIPTitle: '德国ip数量',
  japenIPTitle: '日本ip数量',
  vietnamIPTitle: '越南ip数量',
  brazilIPTitle: '巴西ip数量',
  moreIPTitle: '更多ip数量',

  franceIP: '1,129,487',
  americaIP: '3,878,341',
  britainIP: '2,130,564',
  hongkongIP: '547,098',
  philippinesIP: '802,093',
  canadaIP: '598,214',
  germanyIP: '738,758',
  japenIP: '420,711',
  vietnamIP: '689,609',
  brazilIP: '1,138,236',
  moreIP: '0',

  questionTitle1: '什么是代理？',
  questionTitle2: '如何获取法国代理？',
  questionTitle3: '如何检查我的代理是否正常工作？',
  questionTitle4: '什么是住宅代理？',
  questionText:
    '在IPRocket购买住宅代理后，跳转到获取代理界面，国家选择法国，州和城市可根据需求填写（没有需求即为空白），接着选择网络类型（socks5或http(s)），随后选择轮转模式或粘性模式，最后点击生成，复制生成的url到您的代码或浏览器中就可以使用法国代理了！',

  more: '查看更多',
  franceH1: '最可靠的法国代理',
  franceH2T2: '法国代理价格',
  franceH2T3: '为什么IPRocket的法国代理是最佳选择',
  franceH2T4: '谁适合用法国代理？',
  franceH2T5: '为什么不应该使用免费的法国代理？',
  franceH2T6: '常见问题',
  franceH3: '法国各州代理',
  franceText1:
    '我们的代理拥有令人印象深刻的99.86%的稳定运行时间。目前，我们的代理池包含1,129,487个法国IP地址，这个数字还在不断增长，确保您永远不会用尽选择。通过IPRocket的高级法国代理，您无疑将提升您的代理体验。',
  franceText2:
    '肖蒙,沙朗,圣路易斯,马提尼克,佩尔蒂,洛特河畔新城,瓦龙,圣热拉瓦尔,福尔巴克,瓜德罗普,热蒙,阿吕安,米洛,富热尔,欧什,阿兹布鲁克,圣让德布赖埃',
  franceText3:
    '一款可靠的法国代理服务器为个人用户、组织和企业提供了许多好处。我们的法国代理服务器可以配置用于监控和控制互联网使用，允许您阻止孩子或员工访问特定的网站和服务。它们非常适合数据抓取、互联网营销、广告验证、品牌保护、市场价格监控、抢购限量鞋以及社交媒体管理等任务。',
  franceText3_p2:
    '无论您是个人用户还是企业用户，我们的代理可以防止恶意软件网站侵入您的网络，提升您的在线安全性。通过使用法国IP地址，即使身处其他地方，您也可以看起来像是在法国，从而获得访问BBC iPlayer、Hulu或Netflix等平台的地理限制内容的权限。利用IPRocket，您可以享受这些远远不止这些优势。',
  franceText4:
    '免费的法国代理通常存在重大的安全和隐私风险。这些代理通常来自不可靠和道德上不可取的提供商，可能会导致未来的问题。',
  franceText4_p2:
    '恶意的免费法国代理服务器可能会截取登录详细信息和密码，从而暴露您的个人数据。你无法得知是否有人在使用您的信息，或者他们如何使用它。他们甚至可能会将您的数据出售给第三方以获取利润。',
  franceText4_p3:
    '尽管它们看起来吸引人，但免费的法国代理并非可持续的解决方案。它们不仅不安全，而且速度慢且不可靠。谁愿意使用缓慢的连接进行浏览呢？为了获得安全高效的体验，建议您使用IPRocket的高级代理服务。',
  franceWhyTitle1: '最快的法国代理服务商之一',
  franceWhyTitle2: '持续扩展的法国代理池',
  franceWhyTitle3: '用我们的法国代理来隐藏自己的身份',
  franceWhyText1:
    '我们为IPRocket在法国市场提供的高速代理引以为傲。这些代理拥有高达99.86%的可用性，保证了快速稳定的连接，并极大降低了IP被阻止的风险。无论您的数据收集需求有多大，我们的法国代理都是理想的公共网络抓取工具。',
  franceWhyText2:
    'IPRocket非常重视开发资源，以满足最苛刻的业务需求。我们持续扩展和优化我们的住宅代理池，确保能够提供高品质、高可靠性的服务。除了增加代理数量外，我们还不断升级和扩展各种代理类型，如Socks5、HTTP(S)，以满足不同客户的特定需求和应用场景。',
  franceWhyText3:
    '当谈及在线隐私问题时，许多人关注法国政府可能收集大量公民和互联网用户的数据。因此，选择一个信誉良好的法国代理服务商显得尤为重要。IPRocket的私人代理服务能够有效掩盖您的真实IP地址，并使用强大的加密技术保护您的网络流量，从而极大地增强您的在线隐私保护。',
  franceBtn: '获取法国代理',

  americaH1: '最可靠的美国代理',
  americaH2T2: '美国代理价格',
  americaH2T3: '为什么IPRocket的美国代理是最佳选择',
  americaH2T4: '谁适合用美国代理？',
  americaH2T5: '为什么不应该使用免费的美国代理？',
  americaH2T6: '常见问题',
  americaH3: '美国各州代理',
  americaText1:
    '我们的代理拥有令人印象深刻的99.86%的稳定运行时间。目前，我们的代理池包含1,129,487个美国IP地址，这个数字还在不断增长，确保您永远不会用尽选择。通过IPRocket的高级美国代理，您无疑将提升您的代理体验。',
  americaText2:
    '阿拉斯加州、德克萨斯州、俄亥俄州、加利福尼亚州、哥伦比亚特区、华盛顿、密歇根州、夏威夷、明尼苏达州、乔治亚州',
  americaText3:
    '使用美国代理的方法是无穷无尽的。美国是全球最发达的经济体，数以千计的企业都在寻求在那里扩展业务的机会。作为企业，您可以利用代理收集市场情报，验证广告效果，获取本地的谷歌搜索结果页面，创建多个社交媒体账号等等。 同时，作为家庭用户，您可以访问最大的流媒体库，并显著提升您的在线隐私保护。对于担心在揭露犯罪活动时可能遭遇安全威胁的记者们，使用代理也是至关重要的。在数据泄露问题层出不穷的今天，投资一些在线安全措施是再合适不过的了。',
  americaText4:
    '美国是技术力很高的国家，但同时也藏有复杂的网络犯罪分子。使用免费的美国代理可能会招来麻烦，因为这些代理通常安全措施薄弱甚至没有。网络犯罪分子可以轻易利用这些漏洞来获取您的敏感数据。在最好的情况下，您的信息可能会被出售给广告商。然而，后果可能更严重，比如丢失银行凭据并遭受重大财务损失。为了避免这些风险，请选择付费和优质的美国代理来进行您的在线活动。',
  americaWhyTitle1: '最快的美国代理服务商之一',
  americaWhyTitle2: '持续扩展的美国代理池',
  americaWhyTitle3: '用我们的美国代理来隐藏自己的身份',
  americaWhyText1:
    '我们为IPRocket在美国市场提供的高速代理引以为傲。这些代理拥有高达99.86%的可用性，保证了快速稳定的连接，并极大降低了IP被阻止的风险。无论您的数据收集需求有多大，我们的美国代理都是理想的公共网络抓取工具。',
  americaWhyText2:
    'IPRocket非常重视开发资源，以满足最苛刻的业务需求。我们持续扩展和优化我们的住宅代理池，确保能够提供高品质、高可靠性的服务。除了增加代理数量外，我们还不断升级和扩展各种代理类型，如Socks5、HTTP(S)，以满足不同客户的特定需求和应用场景。',
  americaWhyText3:
    '当谈及在线隐私问题时，许多人关注美国政府可能收集大量公民和互联网用户的数据。因此，选择一个信誉良好的美国代理服务商显得尤为重要。IPRocket的私人代理服务能够有效掩盖您的真实IP地址，并使用强大的加密技术保护您的网络流量，从而极大地增强您的在线隐私保护。',
  americaBtn: '获取美国代理',

  britainH1: '最可靠的英国代理',
  britainH2T2: '英国代理价格',
  britainH2T3: '最可靠的为什么IPRocket的英国代理是最佳选择英国代理',
  britainH2T4: '谁适合用英国代理？',
  britainH2T5: '为什么不应该使用免费的英国代理？',
  britainH2T6: '常见问题',
  britainH3: '英国各州代理',
  britainText1:
    '我们的代理拥有令人印象深刻的99.86%的稳定运行时间。目前，我们的代理池包含1,129,487个英国IP地址，这个数字还在不断增长，确保您永远不会用尽选择。通过IPRocket的高级英国代理，您无疑将提升您的代理体验。',
  britainText2:
    '剑桥,苏格兰,费尔顿,霍尔比奇,德斯伯勒,阿德罗森,艾尔斯福德,伊肯纳姆,布兰德福德论坛,卡斯尔顿,金斯坦顿,诺尔,莫斯利,模子,查尔顿国王队,伊尔弗勒科姆',
  britainText3:
    '代理可以被企业和普通互联网用户广泛使用。企业通过能够抓取在线数据、探索不同市场并利用代理增强其数字营销决策而获得显著好处。我们的英国IP地址允许企业主控制其社交媒体营销活动，并提供匿名性以保守这些公司决策的机密性。',
  britainText3_p2:
    '普通互联网用户在访问在线内容时会发现代理非常有帮助。如果您在英国以外旅行，可能会无法访问BBC iPlayer，错过一生中难得的体育赛事，或者无法观看仅在英国上映的Netflix电视节目。IPRocket的代理可以轻松绕过这些地理限制，同时增强您的在线安全性！',
  britainText4:
    '使用免费的英国代理存在显著的缺点。主要问题是安全性。免费代理可能会将您的敏感数据暴露给第三方，无论您是进行营销活动、数据抓取还是绕过地理限制。这些信息可能会被出售给广告商，或更糟糕的是，您的个人凭据可能会被盗取，导致严重后果。此外，与多个用户共享免费代理会极大地降低其速度，导致连接变得非常缓慢和令人沮丧。此外，免费代理通常携带恶意软件，对您的设备和未来所有活动构成重大风险。因此，强烈建议选择IPRocket这样提供付费服务的英国网络代理商。',
  britainWhyTitle1: '最快的英国代理服务商之一',
  britainWhyTitle2: '持续扩展的英国代理池',
  britainWhyTitle3: '用我们的英国代理来隐藏自己的身份',
  britainWhyText1:
    '我们为IPRocket在英国市场提供的高速代理引以为傲。这些代理拥有高达99.86%的可用性，保证了快速稳定的连接，并极大降低了IP被阻止的风险。无论您的数据收集需求有多大，我们的英国代理都是理想的公共网络抓取工具。',
  britainWhyText2:
    'IPRocket非常重视开发资源，以满足最苛刻的业务需求。我们持续扩展和优化我们的住宅代理池，确保能够提供高品质、高可靠性的服务。除了增加代理数量外，我们还不断升级和扩展各种代理类型，如Socks5、HTTP(S)，以满足不同客户的特定需求和应用场景。',
  britainWhyText3:
    '当谈及在线隐私问题时，许多人关注英国政府可能收集大量公民和互联网用户的数据。因此，选择一个信誉良好的英国代理服务商显得尤为重要。IPRocket的私人代理服务能够有效掩盖您的真实IP地址，并使用强大的加密技术保护您的网络流量，从而极大地增强您的在线隐私保护。',
  britainBtn: '获取英国代理',

  hongkongH1: '最可靠的香港代理',
  hongkongH2T2: '香港代理价格',
  hongkongH2T3: '最可靠的为什么IPRocket的香港代理是最佳选择香港代理',
  hongkongH2T4: '谁适合用香港代理？',
  hongkongH2T5: '为什么不应该使用免费的香港代理？',
  hongkongH2T6: '常见问题',
  hongkongH3: '香港各州代理',
  hongkongText1:
    '我们的代理拥有令人印象深刻的99.86%的稳定运行时间。目前，我们的代理池包含1,129,487个香港IP地址，这个数字还在不断增长，确保您永远不会用尽选择。通过IPRocket的高级香港代理，您无疑将提升您的代理体验。',
  hongkongText2: '中西区、九龙区、葵青区、荃湾区',
  hongkongText3:
    'IPRocket提供多种定制选项，为所有人的需求提供香港IP地址。家庭用户可以享受流媒体服务、新闻网站以及更低的消费品价格，同时获得增强的隐私保护。企业客户可以利用我们的代理服务，在最快的速度下抓取市场数据，从而在竞争激烈的市场中获得竞争优势。在今天的市场环境中，如果没有准确的数据支持，成功的投资是非常具有挑战性的。我们的香港代理网络确保可靠的数据抓取，零故障率和99.86%的稳定运行时间。如有任何进一步问题，请随时联系我们！',
  hongkongText4:
    '免费代理通常带来的麻烦比它们的价值更大。网络犯罪分子经常针对免费代理用户，因为这些服务缺乏强大的网络安全功能。例如，免费代理可能使用过时的加密算法（或者根本没有加密），使得网络犯罪分子可以监视您的在线活动并提取有价值的数据。这些数据随后可以用于发动更复杂的网络攻击，感染您的设备。最终，他们可以获取您的社交媒体密码、个人聊天记录和银行详细信息。后果可能从社交媒体账号被封禁到银行账户被清空不等。为避免不必要的风险，请使用像IPRocket这样的付费和信誉良好的代理服务。',
  hongkongWhyTitle1: '最快的香港代理服务商之一',
  hongkongWhyTitle2: '持续扩展的香港代理池',
  hongkongWhyTitle3: '用我们的香港代理来隐藏自己的身份',
  hongkongWhyText1:
    '我们为IPRocket在香港市场提供的高速代理引以为傲。这些代理拥有高达99.86%的可用性，保证了快速稳定的连接，并极大降低了IP被阻止的风险。无论您的数据收集需求有多大，我们的香港代理都是理想的公共网络抓取工具。',
  hongkongWhyText2:
    'IPRocket非常重视开发资源，以满足最苛刻的业务需求。我们持续扩展和优化我们的住宅代理池，确保能够提供高品质、高可靠性的服务。除了增加代理数量外，我们还不断升级和扩展各种代理类型，如Socks5、HTTP(S)，以满足不同客户的特定需求和应用场景。',
  hongkongWhyText3:
    '我们确保我们的香港代理与第三方软件（例如浏览器的代理 IP 地址管理工具）轻松集成。我们在博客中创建了教程，以实现无忧的集成过程。获取我们的香港代理，确保您无需处理复杂的集成。',
  hongkongBtn: '获取香港代理',

  philippinesH1: '最可靠的菲律宾代理',
  philippinesH2T2: '菲律宾代理价格',
  philippinesH2T3: '最可靠的为什么IPRocket的菲律宾代理是最佳选择菲律宾代理',
  philippinesH2T4: '谁适合用菲律宾代理？',
  philippinesH2T5: '为什么不应该使用免费的菲律宾代理？',
  philippinesH2T6: '常见问题',
  philippinesH3: '菲律宾各州代理',
  philippinesText1:
    '我们的代理拥有令人印象深刻的99.86%的稳定运行时间。目前，我们的代理池包含1,129,487个菲律宾IP地址，这个数字还在不断增长，确保您永远不会用尽选择。通过IPRocket的高级菲律宾代理，您无疑将提升您的代理体验。',
  philippinesText2:
    '卡尔卡尔,拜拜,巴亚万,塔布克,加潘,力高,佬沃,纳加,第波罗,圣卡洛斯,塔瓦科,卡拉潘,奥罗基耶塔,卡巴巴兰,马阿辛,马斯巴特,巴朗牙,卡巴洛甘,萨马尔',
  philippinesText3:
    'IPRocket提供菲律宾住宅代理，以满足各种需求。企业所有者、营销人员和开发者可以利用这些代理进行网页抓取、广告验证、SEO监控、网页测试、社交媒体管理、内容管理等业务应用。',
  philippinesText3_p2:
    '学校、图书馆和大学可以使用我们的代理来限制访问特定的网站和在线内容。个人用户可以利用它们进行多种用途，如安全购买限量版运动鞋、在线游戏、避免被监控以及从国外访问新加坡的内容平台。',
  philippinesText3_p3:
    '无论您是企业所有者、营销人员、开发者、网页测试人员、机构管理者、家长，还是普通的互联网用户，我们可靠的菲律宾代理都可以极大地满足您的需求',
  philippinesText4:
    '免费的菲律宾代理可能会限制您的带宽，并且有可能泄露您的私人数据。这些代理通常是非法获取并且同时被多个用户共享，因此不适合进行游戏、流媒体、下载种子、网页抓取以及其他活动。',
  philippinesText4_p2:
    '一些免费代理甚至可能通过出售或分享您的个人或财务信息给营销商或其他第三方来侵犯您的在线隐私。基于这些原因，我们建议避免使用免费的菲律宾代理，而是选择来自可信赖提供商（如IPRocket）的可靠和高级代理。我们的菲律宾代理来源合法，完全匿名，安全可靠。',
  philippinesWhyTitle1: '最快的菲律宾代理服务商之一',
  philippinesWhyTitle2: '持续扩展的菲律宾代理池',
  philippinesWhyTitle3: '用我们的菲律宾代理来隐藏自己的身份',
  philippinesWhyText1:
    '我们为IPRocket在菲律宾市场提供的高速代理引以为傲。这些代理拥有高达99.86%的可用性，保证了快速稳定的连接，并极大降低了IP被阻止的风险。无论您的数据收集需求有多大，我们的菲律宾代理都是理想的公共网络抓取工具。',
  philippinesWhyText2:
    'IPRocket非常重视开发资源，以满足最苛刻的业务需求。我们持续扩展和优化我们的住宅代理池，确保能够提供高品质、高可靠性的服务。除了增加代理数量外，我们还不断升级和扩展各种代理类型，如Socks5、HTTP(S)，以满足不同客户的特定需求和应用场景。',
  philippinesWhyText3:
    '我们确保我们的菲律宾代理与第三方软件（例如浏览器的代理 IP 地址管理工具）轻松集成。我们在博客中创建了教程，以实现无忧的集成过程。获取我们的菲律宾代理，确保您无需处理复杂的集成。',
  philippinesBtn: '获取菲律宾代理',

  canadaH1: '最可靠的加拿大代理',
  canadaH2T2: '加拿大代理价格',
  canadaH2T3: '最可靠的为什么IPRocket的加拿大代理是最佳选择加拿大代理',
  canadaH2T4: '谁适合用加拿大代理？',
  canadaH2T5: '为什么不应该使用免费的加拿大代理？',
  canadaH2T6: '常见问题',
  canadaH3: '加拿大各州代理',
  canadaText1:
    '我们的代理拥有令人印象深刻的99.86%的稳定运行时间。目前，我们的代理池包含1,129,487个加拿大IP地址，这个数字还在不断增长，确保您永远不会用尽选择。通过IPRocket的高级加拿大代理，您无疑将提升您的代理体验。',
  canadaText2:
    '韦尔斯利,艾略特湖,兰伯顿海岸,纳尔逊,坎特利,威廉姆斯湖,米福德,拉圖克,埃斯特万,诺里奇,沃曼,北萨尼奇,金卡丁,艾琳,蒙马尼,南休伦,',
  canadaText3:
    '我们的加拿大IP地址提供广泛的定制选项，适合各类用户需求。家庭用户可以享受更加无限制的互联网体验，绕过地理限制，并可能找到更便宜的旅行优惠。代理还能增强在线隐私，保护用户免受不必要的关注。',
  canadaText3_p2:
    '另一方面，企业利用代理进行各种营销策略。从监控竞争对手和识别其所在领域内受欢迎的产品，到执行精准的社交媒体广告活动，代理已经彻底改变了数字营销的方式。在当今数字化的环境中，一家可靠的加拿大代理服务器提供商的价值不可低估。',
  canadaText4:
    '有两个主要原因要避免使用免费代理服务。首先，它们的安全措施薄弱，通常会泄露用户数据。这些被泄露的数据可能被用来感染设备、窃取社交媒体账号，甚至获取银行详细信息。许多故事详细描述了成功的Instagram影响者因为数字身份保护不足而失去账号和收入。',
  canadaText4_p2:
    '其次，免费加拿大代理通常速度很慢。对于像流媒体或营销这样的活动，您需要快速的代理。然而，与许多用户共享一个免费代理会显著降低您的连接速度。基于这些原因，选择IPRocket安全高速的代理服务会更加明智。',
  canadaWhyTitle1: '最快的加拿大代理服务商之一',
  canadaWhyTitle2: '持续扩展的加拿大代理池',
  canadaWhyTitle3: '用我们的加拿大代理来隐藏自己的身份',
  canadaWhyText1:
    '我们为IPRocket在加拿大市场提供的高速代理引以为傲。这些代理拥有高达99.86%的可用性，保证了快速稳定的连接，并极大降低了IP被阻止的风险。无论您的数据收集需求有多大，我们的加拿大代理都是理想的公共网络抓取工具。',
  canadaWhyText2:
    'IPRocket非常重视开发资源，以满足最苛刻的业务需求。我们持续扩展和优化我们的住宅代理池，确保能够提供高品质、高可靠性的服务。除了增加代理数量外，我们还不断升级和扩展各种代理类型，如Socks5、HTTP(S)，以满足不同客户的特定需求和应用场景。',
  canadaWhyText3:
    '我们确保我们的加拿大代理与第三方软件（例如浏览器的代理 IP 地址管理工具）轻松集成。我们在博客中创建了教程，以实现无忧的集成过程。获取我们的加拿大代理，确保您无需处理复杂的集成。',
  canadaBtn: '获取加拿大代理',

  germanyH1: '最可靠的德国代理',
  germanyH2T2: '德国代理价格',
  germanyH2T3: '最可靠的为什么IPRocket的德国代理是最佳选择德国代理',
  germanyH2T4: '谁适合用德国代理？',
  germanyH2T5: '为什么不应该使用免费的德国代理？',
  germanyH2T6: '常见问题',
  germanyH3: '德国各州代理',
  germanyText1:
    '我们的代理拥有令人印象深刻的99.86%的稳定运行时间。目前，我们的代理池包含1,129,487个德国IP地址，这个数字还在不断增长，确保您永远不会用尽选择。通过IPRocket的高级德国代理，您无疑将提升您的代理体验。',
  germanyText2:
    '瓦尔德基尔兴,里德林根,库埃尔富尔特,盖恩斯海姆,利希特瑙,诺森,费尔斯贝格,布莱歇罗德,德明,布罗因斯贝德拉,戈梅尔恩,阿尔多廷,泰克山麓魏尔海姆',
  germanyText3:
    '对许多用户来说，一个可靠的德国代理服务可以带来诸多优势。企业通常利用代理服务进行市场数据抓取、社交媒体活动管理、广告验证、SEO跟踪以及其他运营需求。学校和大学等教育机构使用代理来控制在线内容访问。',
  germanyText3_p2:
    '家庭用户也因代理服务提升了在线隐私和安全性，使其能够享受更开放的互联网体验而感到满意。通过将原始IP地址隐藏在代理服务器后面，个人在网上被跟踪的难度大大增加。此外，切换IP地址还允许用户绕过地理限制，访问更广泛的在线内容',
  germanyText4:
    '有几个理由需要避免使用德国的免费代理服务。一个主要的担忧是提供免费服务背后的动机。通常情况下，开发者通过窃取用户数据来获取利润。免费代理可能会强制网页以HTTP加载，绕过加密，暴露您的在线活动。如果网络犯罪分子设置了一个免费代理来监视流量，他们可以进一步利用您的数据。',
  germanyText4_p2:
    '另一个问题是服务提供者的匿名性。很多时候，不可能追溯免费代理服务到真实的个人，因为他们通常隐藏自己的身份。即使执法部门介入，成功解决问题的可能性也非常低。',
  germanyWhyTitle1: '最快的德国代理服务商之一',
  germanyWhyTitle2: '持续扩展的德国代理池',
  germanyWhyTitle3: '用我们的德国代理来隐藏自己的身份',
  germanyWhyText1:
    '我们为IPRocket在德国市场提供的高速代理引以为傲。这些代理拥有高达99.86%的可用性，保证了快速稳定的连接，并极大降低了IP被阻止的风险。无论您的数据收集需求有多大，我们的德国代理都是理想的公共网络抓取工具。',
  germanyWhyText2:
    'IPRocket非常重视开发资源，以满足最苛刻的业务需求。我们持续扩展和优化我们的住宅代理池，确保能够提供高品质、高可靠性的服务。除了增加代理数量外，我们还不断升级和扩展各种代理类型，如Socks5、HTTP(s)，以满足不同客户的特定需求和应用场景。',
  germanyWhyText3:
    '我们确保我们的德国代理与第三方软件（例如浏览器的代理 IP 地址管理工具）轻松集成。我们在博客中创建了教程，以实现无忧的集成过程。获取我们的德国代理，确保您无需处理复杂的集成。',
  germanyBtn: '获取德国代理',

  japenH1: '最可靠的日本代理',
  japenH2T2: '日本代理价格',
  japenH2T3: '最可靠的为什么IPRocket的日本代理是最佳选择日本代理',
  japenH2T4: '谁适合用日本代理？',
  japenH2T5: '为什么不应该使用免费的日本代理？',
  japenH2T6: '常见问题',
  japenH3: '日本各州代理',
  japenText1:
    '我们的代理拥有令人印象深刻的99.86%的稳定运行时间。目前，我们的代理池包含1,129,487个日本IP地址，这个数字还在不断增长，确保您永远不会用尽选择。通过IPRocket的高级日本代理，您无疑将提升您的代理体验。',
  japenText2: '东京、萨卡、神奈川县、冲绳',
  japenText3:
    '几乎任何人在计划前往日本旅行或进行业务活动时都可以从日本IP地址中受益。日本拥有快速增长的信息技术行业、丰富的消费品种类以及众多的投资机会。此外，日本还拥有独特的文化、全球知名的电视节目和非凡的假日体验。',
  japenText3_p2:
    '如果日本距离您有一段距离，IPRocket提供的高速代理将确保您在营销活动或观看电视节目时获得最大的速度。您还将享受到增强的隐私保护，降低您的在线活动受到不必要关注的风险。',
  japenText4:
    '免费的日本代理信号不佳。日本是一个技术先进的国家，他们的网络犯罪分子可以利用最新的技术来攻击毫无戒备的用户。免费代理可能看起来吸引人，但它们的开发者需要通过某种方式赚钱。他们可能会将您的数据卖给出价最高的买家，使用免费代理也会面临丢失在线凭据的风险，这可能导致严重的财务损失。为了避免不必要的问题，最好依赖于付费的高级日本代理。',
  japenText4_p2:
    '此外，付费代理比免费代理速度快得多，因此如果您想以高质量流畅地观看日本内容，投资于IPRocket提供的优质代理服务是至关重要的',
  japenWhyTitle1: '最快的日本代理服务商之一',
  japenWhyTitle2: '持续扩展的日本代理池',
  japenWhyTitle3: '用我们的日本代理来隐藏自己的身份',
  japenWhyText1:
    '我们为IPRocket在日本市场提供的高速代理引以为傲。这些代理拥有高达99.86%的可用性，保证了快速稳定的连接，并极大降低了IP被阻止的风险。无论您的数据收集需求有多大，我们的日本代理都是理想的公共网络抓取工具。',
  japenWhyText2:
    'IPRocket非常重视开发资源，以满足最苛刻的业务需求。我们持续扩展和优化我们的住宅代理池，确保能够提供高品质、高可靠性的服务。除了增加代理数量外，我们还不断升级和扩展各种代理类型，如Socks5、HTTP(s)，以满足不同客户的特定需求和应用场景。',
  japenWhyText3:
    '我们确保我们的日本代理与第三方软件（例如浏览器的代理 IP 地址管理工具）轻松集成。我们在博客中创建了教程，以实现无忧的集成过程。获取我们的日本代理，确保您无需处理复杂的集成。',
  japenBtn: '获取日本代理',

  vietnamH1: '最可靠的越南代理',
  vietnamH2T2: '越南代理价格',
  vietnamH2T3: '最可靠的为什么IPRocket的越南代理是最佳选择越南代理',
  vietnamH2T4: '谁适合用越南代理？',
  vietnamH2T5: '为什么不应该使用免费的越南代理？',
  vietnamH2T6: '常见问题',
  vietnamH3: '越南各州代理',
  vietnamText1:
    '我们的代理拥有令人印象深刻的99.86%的稳定运行时间。目前，我们的代理池包含1,129,487个越南IP地址，这个数字还在不断增长，确保您永远不会用尽选择。通过IPRocket的高级越南代理，您无疑将提升您的代理体验。',
  vietnamText2: '布克江省、海防、河内、胡志明、恩奈省、蒂布省、西藏省、南安省、布隆省、北宁省、北江省',
  vietnamText3:
    '网络安全专家建议使用代理来增强在线隐私保护。对于专业的网络犯罪分子，通过IP地址追踪通常相对容易。如果您在进行在线业务，使用代理服务器隐藏您的原始IP地址是减少不必要风险的明智选择。',
  vietnamText3_p2:
    '可靠的代理服务为营销操作提供了许多好处。使用越南代理的用户可以创建和管理多个社交媒体账号，绕过地理限制，直接与消费者互动，进行广告验证等。这有助于增加投资机会，并实现更安全的在线业务实践。立即联系IPRocket，我们将帮助您找到最适合您需求的代理服务方案。',
  vietnamText4:
    '使用免费的越南代理可能会带来更多问题，原因有几点。首先，连接速度对代理用户至关重要，而免费代理无法保证这一点。通常情况下，您会与其他用户共享代理服务器，如果他们正在下载大文件或者观看高质量视频，您的连接速度将会显著降低。这在抓取竞争对手数据或者比较价格时特别成问题，因为延迟可能导致您错过重要的投资机会。',
  vietnamText4_p2:
    '此外，安全性是一个主要关注点。大多数免费代理缺乏强大的安全功能，使它们成为网络犯罪分子的主要目标。如果您进行在线银行操作，避免使用免费的越南代理来保护您的敏感信息至关重要。选择像IPRocket这样可靠的服务将为您提供所需的速度和安全保障。',
  vietnamWhyTitle1: '最快的越南代理服务商之一',
  vietnamWhyTitle2: '持续扩展的越南代理池',
  vietnamWhyTitle3: '用我们的越南代理来隐藏自己的身份',
  vietnamWhyText1:
    '我们为IPRocket在越南市场提供的高速代理引以为傲。这些代理拥有高达99.86%的可用性，保证了快速稳定的连接，并极大降低了IP被阻止的风险。无论您的数据收集需求有多大，我们的越南代理都是理想的公共网络抓取工具。',
  vietnamWhyText2:
    'IPRocket非常重视开发资源，以满足最苛刻的业务需求。我们持续扩展和优化我们的住宅代理池，确保能够提供高品质、高可靠性的服务。除了增加代理数量外，我们还不断升级和扩展各种代理类型，如Socks5、HTTP(s)，以满足不同客户的特定需求和应用场景。',
  vietnamWhyText3:
    '我们确保我们的越南代理与第三方软件（例如浏览器的代理 IP 地址管理工具）轻松集成。我们在博客中创建了教程，以实现无忧的集成过程。获取我们的越南代理，确保您无需处理复杂的集成。',
  vietnamBtn: '获取越南代理',

  brazilH1: '最可靠的巴西代理',
  brazilH2T2: '巴西代理价格',
  brazilH2T3: '最可靠的为什么IPRocket的巴西代理是最佳选择巴西代理',
  brazilH2T4: '谁适合用巴西代理？',
  brazilH2T5: '为什么不应该使用免费的巴西代理？',
  brazilH2T6: '常见问题',
  brazilH3: '巴西各州代理',
  brazilText1:
    '我们的代理拥有令人印象深刻的99.86%的稳定运行时间。目前，我们的代理池包含1,129,487个巴西IP地址，这个数字还在不断增长，确保您永远不会用尽选择。通过IPRocket的高级巴西代理，您无疑将提升您的代理体验。',
  brazilText2:
    '巴塞卢什,阿尔蒂诺波利斯,奥里夫拉马,温福,平多拉马,圣阿德利亚,图皮保利斯塔,伊塔若比,巴迪巴斯特,佩德雷古柳,沙尔克阿达,埃尔多拉多,布里塔马',
  brazilText3:
    '巴西广阔的国土确保了代理服务能够以多种方式惠及各类用户。例如，使用巴西IP地址可以帮助您获得更便宜的机票或酒店房价。当您前往巴西时，连接到我们的私人代理服务器可以隐藏您的IP地址并加密您的数据，提供额外的安全保障，防止潜在的网络攻击。',
  brazilText3_p2:
    '企业所有者可以利用代理来监控SEO趋势，抓取巴西在线市场数据，管理多个社交媒体账号，防止欺诈，验证广告活动效果。根据您的业务需求，每种方式都提供不同的优势，适用于各种操作。',
  brazilText4:
    '免费代理从未是一个好选择，特别是在考虑到巴西时更是如此。2021年，巴西是受勒索软件攻击影响最严重的四个国家之一。如果在那里进行业务活动，保持警惕至关重要，因为勒索软件团伙经常针对未受保护的在线企业，加密其数据并要求高额赎金，这可能严重影响正在发展中的企业。',
  brazilText4_p2:
    '免费代理通常缺乏足够的网络安全措施，因此经常成为网络犯罪分子的目标。选择像IPRocket这样声誉良好的付费代理服务提供商可以确保额外的网络安全功能，保护您的数据。我们的代理服务器专为防止机密信息在网上泄露而设计，为您的在线活动提供安心保障。',
  brazilWhyTitle1: '最快的巴西代理服务商之一',
  brazilWhyTitle2: '持续扩展的巴西代理池',
  brazilWhyTitle3: '用我们的巴西代理来隐藏自己的身份',
  brazilWhyText1:
    '我们为IPRocket在巴西市场提供的高速代理引以为傲。这些代理拥有高达99.86%的可用性，保证了快速稳定的连接，并极大降低了IP被阻止的风险。无论您的数据收集需求有多大，我们的巴西代理都是理想的公共网络抓取工具。',
  brazilWhyText2:
    'IPRocket非常重视开发资源，以满足最苛刻的业务需求。我们持续扩展和优化我们的住宅代理池，确保能够提供高品质、高可靠性的服务。除了增加代理数量外，我们还不断升级和扩展各种代理类型，如Socks5、HTTP(s)，以满足不同客户的特定需求和应用场景。',
  brazilWhyText3:
    '我们确保我们的巴西代理与第三方软件（例如浏览器的代理 IP 地址管理工具）轻松集成。我们在博客中创建了教程，以实现无忧的集成过程。获取我们的巴西代理，确保您无需处理复杂的集成。',
  brazilBtn: '获取巴西代理',

  moreH2T1: '为什么选择IPRocket？',
  moreH2T2: '所有国家',
  moreText1:
    '当您使用代理时，您的真实IP地址会被替换为您选择的新IP地址，从而实现完全匿名的互联网访问体验。IPRocket提供高速的住宅代理，确保超过99.86%的稳定运行时间，为您提供业界领先的速度、稳定性、安全性和个性化服务。 ',
  moreText1_1:
    '我们专注于为企业和个人用户提供量身定制的解决方案，满足各种使用场景的需求。您可以选择特定的大洲、地区甚至城市，以确保代理服务完全符合您的预期。只需几次点击，您即可在我们的仪表板页面上轻松设置和管理全新的代理。',
  moreText1_2:
    '无论您是需要在全球不同地区执行数据抓取、市场分析，还是希望解锁特定地区的网站和服务，IPRocket的代理服务都能为您提供卓越的性能和保障。让我们帮助您实现在线活动的安全与自由！',
  moreText2:
    '网络安全专家建议使用代理来增强在线隐私保护。对于专业的网络犯罪分子，通过IP地址追踪通常相对容易。如果您在进行在线业务，使用代理服务器隐藏您的原始IP地址是减少不必要风险的明智选择。 可靠的代理服务为营销操作提供了许多好处。用户可以创建和管理多个社交媒体账号，绕过地理限制，直接与消费者互动，进行广告验证等。这有助于增加投资机会，并实现更安全的在线业务实践。 在IPRocket，我们最受欢迎的产品是符合道德标准的住宅代理，它拥有60-90天的超长有效期和的99.05%的卓越成功率。通过按量付费的定价模式，客户可以订购项目所需的精确流量。我们的全球住宅代理起价仅为 3.5 美元/GB，物超所值。批量折扣可将大型项目的成本降低至惊人的 0.9 美元/GB。',
  Aisa: '亚洲',
  Europe: '欧洲',
  NorthAmerica: '北美洲',
  SouthAmerica: '南美洲',
  Oceania: '大洋洲',

  Bhutan: '不丹',
  TimorLeste: '东帝汶',
  China: '中国',
  Uzbekistan: '乌兹别克斯坦',
  Yemen: '也门',
  Armenia: '亚美尼亚',
  Israel: '以色列',
  Iraq: '伊拉克',
  Ira: '伊朗',
  Qatar: '卡塔尔',
  Indonesia: '印尼',
  India: '印度',
  Syria: '叙利亚',
  Kyrgyzstan: '吉尔吉斯斯坦',
  Kazakhstan: '哈萨克斯坦',
  Shikumenstein: '士库曼斯坦',
  Tajikistan: '塔吉克斯坦',
  Bangladesh: '孟加拉',
  Nepal: '尼泊尔',
  Pakistan: '巴基斯坦',
  Palestine: '帕勒斯坦',
  Brunei: '文莱',
  SriLanka: '斯里兰卡',
  Singapore: '新加坡',
  Japan: '日本',
  Cambodia: '柬埔寨',
  SaudiArabia: '沙特阿拉伯',
  Thailand: '泰国',
  Theturkey: '火鸡',
  Kuwait: '科威特',
  Jordan: '约旦',
  Myanmar: '缅甸',
  Laos: '老挝',
  Lebanon: '莱巴嫩',
  Philippines: '菲律宾',
  Mongolia: '蒙古',
  Vietna: '越南',
  Azerbaijan: '阿塞拜疆',
  Afghanistan: '阿富汗',
  Oman: '阿曼',
  TheUnitedArabEmirates: '阿联酋',
  SouthKorea: '韩国',
  Maldives: '马尔代夫',
  Malaysia: '马来西亚',

  Denmark: '丹麦',
  Ukraine: '乌克兰',
  Russia: '俄国',
  Bulgaria: '保加利亚',
  Croatia: '克罗地亚',
  Iceland: '冰岛',
  Liechtenstein: '列支敦士登',
  Hungary: '匈牙利',
  NorthernCyprus: '北塞浦路斯',
  Luxembourg: '卢森堡',
  SanMarino: '圣马力诺',
  Serbia: '塞尔维亚',
  Cyprus: '塞浦路斯',
  Austria: '奥地利',
  Andorra: '安道尔',
  Greece: '希腊',
  Italy: '意大利',
  Latvia: '拉脱维亚',
  Norway: '挪威',
  TheCzechRepublic: '捷克共和国  ',
  Moldova: '摩尔多瓦',
  Monaco: '摩纳哥',
  Slovakia: '斯洛伐克',
  Slovenia: '斯洛文尼亚',
  Belgium: '比利时',
  Poland: '波兰',
  BosniaAndHerzegovina: '波黑',
  Ireland: '爱尔兰',
  Estonia: '爱沙尼亚',
  Sweden: '瑞典',
  Switzerland: '瑞士',
  Belarus: '白俄罗斯',
  Gibraltar: '直布罗陀',
  Kosovo: '科索沃',
  Lithuania: '立陶宛',
  Romania: '罗马尼亚',
  Finland: '芬兰',
  TheNetherlands: '荷兰',
  Portugal: '葡萄牙',
  Monteneglo: '蒙特内格鲁',
  Spain: '西班牙',
  Albania: '阿尔巴尼亚',
  Macedonia: '马其顿',
  Malta: '马耳他',

  Belize: '伯利兹',
  Guatemala: '危地马拉',
  Cuba: '古巴',
  GothaShida: '哥打士打',
  DominicanRepublic: '多米尼加',
  Nicaragua: '尼加拉瓜',
  TheBahamas: '巴哈马',
  Panama: '巴拿马',
  Greenland: '格陵兰',
  PuertoRico: '波多黎各',
  Honduras: '洪都拉斯',
  Haiti: '海地',
  Jamaica: '牙买加',
  TrinidadAndTobago: '特立尼达和多巴哥',
  Bermuda: '百慕大',
  ElSalvador: '萨尔瓦多',
  Mexico: '墨西哥',

  Uruguay: '乌拉圭',
  Ecuador: '厄瓜多尔',
  Colombia: '哥伦比亚',
  Guyana: '圭亚那',
  Venezuela: '委内瑞拉',
  Paraguay: '巴拉圭',
  Chile: '智利',
  FrenchGuiana: '法属圭亚那',
  Bolivia: '玻利维亚',
  FalklandIslands: '福克兰群岛',
  Peru: '秘鲁',
  Suriname: '苏里南',
  Argentina: '阿根廷',

  PapuaNewGuinea: '巴布亚新几内亚',
  SolomonIslands: '所罗门群岛',
  Fiji: '斐济',
  NewCaledonia: '新喀里多尼亚',
  NewZealand: '新西兰',
  Australia: '澳大利亚',
  Vanuatu: '瓦努阿图',

  aboutUSH1: 'IPRocket 代理',
  aboutUSText1:
    '自成立以来，IPRocket迅速成长，从最初的几个人壮大为一个庞大且充满活力的国际团队。凭借透明的运营、可靠的解决方案以及完全可定制的定价策略，我们迅速赢得了声誉，服务对象包括财富500强企业、个体经营者以及介于两者之间的所有人。在 IPRocket，我们坚信每个人都应无障碍地获取在线信息——无论是企业、数据科学家、开发人员、营销人员，还是其他有需求的用户。我们致力于通过创新服务、优越的性价比和卓越的客户体验，使每个人都能获取数据。',
  contactUSH1: '联系IPRocket',
  contactUSText1:
    '如果您有任何疑问，请随时通过我们的反馈表或任何其他便捷的沟通方式与我们联系。我们的经理 24/7 在线，随时为您提供帮助并解决您可能遇到的任何问题。',
  developmentH2: '发展历程',
  '': '',
  whatProxy:
    '答：代理是一种连接设备与互联网的方式，使用自身的IP地址作为中介。它处理您的请求、隐藏您的真实IP，并根据需要提供各种功能，确保隐私和安全。',
  isWorking:
    '答：您可以向https://db-ip.com/网站发出请求，结果会告诉您详细的IP地址、IP所在地、IP所属服务商等信息。如果结果与您选择的国家/地区符合，说明代理在正常工作。如果没有代理成功，请向我们的客服求助。',
  whatHouseProxy:
    '答：住宅代理使用互联网服务提供商 (ISP) 分配给设备的独有的IP地址分配给用户设备，从而隐藏用户的真实IP地址和物理位置信息。这种服务特别适用于需要保持匿名性的场合，通过使用住宅代理，用户能够在互联网上进行各种活动而不暴露个人信息，保护隐私安全，因此在网络安全和数据隐私方面具有重要意义。',
  Start: '开始使用',
  '': '',
  '': '',
  '': '',
  '': '',
  '': '',
  '': '',
  '': '',

  statisticsH1: '让我们引以为豪的统计数据',
  statistics1Number: '7,600+',
  statistics1Explain: '全球客户总数',
  statistics2Number: '300+',
  statistics2Explain: '与工具或软件的集成数量',
  statistics3Number: '120+',
  statistics3Explain: '团队成员数量，每周都在增加',
  statistics4Number: '100,000TB+',
  statistics4Explain: '为客户端提供的流量',

  Telegram: 'Telegram',
  Skype: 'Skype',
  Whatsapp: 'Whatsapp',
  Wechat: 'Wechat',

  partenrsH1: 'IPRocket合作伙伴',
  partenrtText1:
    'IPRocket是专业的代理资源服务商，IP资源盖全球210多个国家，成为IPRocket的合作伙伴，您将获得更多的网站曝光量和用户浏览量。申请成为我们的专业合作伙伴，可以帮助您的用户获得更多折扣。',
  partenrtTip1: '全球市场',
  partenrtTip2: '6000w+优秀IP',
  partenrtTip3: '最佳住宅代理服务',
  newBuy: '现在购买',

  homeH1: '高质量住宅代理，快速且稳定!',
  homeReviewP1:
    '我一直在使用IPRocket 的住宅IP 进行网络搜刮，他们提供的服务水平给我留下了深刻印象。IP 是干净的，这对保持匿名性和避免封禁至关重要。',
  homeReviewP2:
    'IPRocket 在数据收集方面的表现超出了我的预期。他们的旋转住宅代理在为我们的研究项目收集市场信息方面发挥了重要作用。',
  homeReviewP3:
    '他们的应用程序接口（API）集成使其能够无缝地融入我们现有的工作流程。如果您需要可靠的代理服务来进行网络搜索或数据挖掘，IPRocket 是您的不二之选。',
  homeQuestionP1: '我能试试你们的住宅代理服务器吗？',
  homeAwensP1: '当然，每位新用户都有一个 1G 流量试用套餐。价格为 $1.99。选择正确的资费并支付费用后，试用就会激活。',
  homeQuestionP2: '网络中可用的 IP 总数是多少？',
  homeAwensP2: '我们的网络拥有 8000 多万个 IP，覆盖 210 多个国家和地区。这一数字仍在不断增长',
  homeQuestionP3: '为什么 IPRocket 比其他代理服务器更快？',
  homeAwensP3:
    'IPRocket 的代理服务利用我们优化的代理网络和流量重定向技术。我们通过全球数百家相关互联网服务提供商（ISP）和互联网节点，在超级代理服务器上部署这一网络。通过这种方式，用户的代理请求将被快速转移到最近的 IP 地址，从而实现超快的速度和极高的网络访问稳定性。',
  homeQuestionP4: '使用住宅 IP 地址合法吗？',
  homeAwensP4:
    '使用住宅 IP 地址（包括通过住宅代理）通常是合法的。住宅 IP 地址由互联网服务提供商 (ISP) 分配给房主，供其个人使用互联网。但是，如何使用住宅 IP 地址或住宅代理服务器可能需要考虑法律因素，具体取决于您从事的具体活动。',
  homeAwensP5: '住宅代理的付款方式有哪些？',
  homeQuestionP6: '我们接受信用卡/借记卡、贝宝、加密货币、银行转账、支付宝等。',
  homeAwensP6:
    '住宅代理是互联网服务提供商（ISP）分配给业主的 IP 地址。它们实质上是您与互联网之间的中介。使用住宅代理时，您的网络请求将通过这些住宅 IP 地址路由，使您的浏览活动看起来像是来自住宅而非数据中心或服务器。IPRocket 代理服务器网络由全球 210多个国家的 IP 地址组成。这些代理服务器通常用于各种用途，包括网络搜索、数据挖掘、市场研究和绕过地理限制。与其他类型的代理相比，这些代理通常被认为更可靠、更合法，因为它们可以模仿真实用户的行为。不过，由于其稀缺性和维护费用，它们可能比其他类型的代理服务器更昂贵。',
  PreciseTarget: '精准定位、无隐藏费用',

  MyBase: '合规是我们业务的基础',
  MyService:
    '我们非常仔细地确保我们的服务符合 GDPR、CCPA 以及世界各地的其他数据相关立法。IPRocket 也是道德网络数据收集倡议的创始成员之一，致力于创造全球最佳实践，并推动监管机构为该行业制定全球合规实践。',

  questionTitle: '常见问题',
  questionHomet1: '问：我能试试你们的住宅代理服务器吗？',
  questionHomet2: '问：网络中可用的IP总数是多少？',
  questionHomet3: '问：为什么IPRocket 比其他代理服务器更快？',
  questionHomet4: '问：使用住宅IP地址合法吗？',
  questionHomet5: '问：居民代理的付款方式有哪些？',
  questionHomet6: '问：什么是住宅代理？',
  questionAnswert1:
    '当然，每位新用户都有一个 1G 流量试用套餐。价格为 $1.99。选择正确的资费并支付费用后，试用就会激活。',
  questionAnswert2: '我们的住宅代理拥有6000多万个IP，高级住宅代理拥有9000多万个IP，您可以根据需求选择适合的套餐。',
  questionAnswert3:
    'IPRocket 的代理服务利用我们优化的代理网络和流量重定向技术。我们通过全球数百家相关互联网服务提供商（ISP）和互联网节点，在超级代理服务器上部署这一网络。通过这种方式，用户的代理请求将被快速转移到最近的 IP 地址，从而实现超快的速度和极高的网络访问稳定性。',
  questionAnswert4:
    '使用住宅 IP 地址（包括通过住宅代理）通常是合法的。住宅 IP 地址由互联网服务提供商 (ISP) 分配给房主，供其个人使用互联网。但是，如何使用住宅 IP 地址或住宅代理服务器可能需要考虑法律因素，具体取决于您从事的具体活动。',
  questionAnswert5: '我们接受信用卡/借记卡、贝宝、加密货币、银行转账、支付宝等。',
  questionAnswert6:
    '住宅代理是互联网服务提供商（ISP）分配给业主的 IP 地址。它们实质上是您与互联网之间的中介。使用住宅代理时，您的网络请求将通过这些住宅 IP 地址路由，使您的浏览活动看起来像是来自住宅而非数据中心或服务器。IPRocket 代理服务器网络由全球 210多个国家的 IP 地址组成。这些代理服务器通常用于各种用途，包括网络搜索、数据挖掘、市场研究和绕过地理限制。与其他类型的代理相比，这些代理通常被认为更可靠、更合法，因为它们可以模仿真实用户的行为。不过，由于其稀缺性和维护费用，它们可能比其他类型的代理服务器更昂贵。',

    thanks: '受服务区域政策影响，中国大陆地区暂无法使用此服务，敬请谅解。',
  pay_thanks:'(此服务在中国大陆地区不可用)',
  productFiveT1:
    '体验我们的住宅代理网络的无限制访问，覆盖210多个国家/地区。利用庞大、稳定的住宅代理网络绕过地理限制，并由专利解决方案提供支持。',

  getAmericaProxy: '如何获取美国代理？',
  getBrazilProxy: '如何获取巴西代理？',
  getBritainProxy: '如何获取英国代理？',
  getCanadaProxy: '如何获取加拿大代理？',
  getGemanyProxy: '如何获取德国代理？',
  getHongkongProxy: '如何获取香港代理？',
  getJapanProxy: '如何获取日本代理？',
  getPhilippinesProxy: '如何获取菲律宾代理？',
  getVietnamProxy: '如何获取越南代理？',

  USAnswert2:
    '答：在IPRocket购买住宅代理后，跳转到获取代理界面，国家选择美国，州和城市可根据需求填写（没有需求即为空白），接着选择网络类型（socks5或http(s)），随后选择轮转模式或粘性模式，最后点击生成，复制生成的url到您的代码或浏览器中就可以使用美国代理了！',
  BrazilAnswert2:
    '答：在IPRocket购买住宅代理后，跳转到获取代理界面，国家选择巴西，州和城市可根据需求填写（没有需求即为空白），接着选择网络类型（socks5或http(s)），随后选择轮转模式或粘性模式，最后点击生成，复制生成的url到您的代码或浏览器中就可以使用巴西代理了！',
  BritainAnswert2:
    '答：在IPRocket购买住宅代理后，跳转到获取代理界面，国家选择英国，州和城市可根据需求填写（没有需求即为空白），接着选择网络类型（socks5或http(s)），随后选择轮转模式或粘性模式，最后点击生成，复制生成的url到您的代码或浏览器中就可以使用英国代理了！',
  CanadaAnswert2:
    '答：在IPRocket购买住宅代理后，跳转到获取代理界面，国家选择加拿大，州和城市可根据需求填写（没有需求即为空白），接着选择网络类型（socks5或http(s)），随后选择轮转模式或粘性模式，最后点击生成，复制生成的url到您的代码或浏览器中就可以使用加拿大代理了！',
  GermanyAnswert2:
    '答：在IPRocket购买住宅代理后，跳转到获取代理界面，国家选择德国，州和城市可根据需求填写（没有需求即为空白），接着选择网络类型（socks5或http(s)），随后选择轮转模式或粘性模式，最后点击生成，复制生成的url到您的代码或浏览器中就可以使用德国代理了！',
  HonekongAnswert2:
    '答：在IPRocket购买住宅代理后，跳转到获取代理界面，国家选择香港，州和城市可根据需求填写（没有需求即为空白），接着选择网络类型（socks5或http(s)），随后选择轮转模式或粘性模式，最后点击生成，复制生成的url到您的代码或浏览器中就可以使用香港代理了！',
  JapanAnswert2:
    '答：在IPRocket购买住宅代理后，跳转到获取代理界面，国家选择日本，州和城市可根据需求填写（没有需求即为空白），接着选择网络类型（socks5或http(s)），随后选择轮转模式或粘性模式，最后点击生成，复制生成的url到您的代码或浏览器中就可以使用日本代理了！',
  PholippinesAnswert2:
    '答：在IPRocket购买住宅代理后，跳转到获取代理界面，国家选择菲律宾，州和城市可根据需求填写（没有需求即为空白），接着选择网络类型（socks5或http(s)），随后选择轮转模式或粘性模式，最后点击生成，复制生成的url到您的代码或浏览器中就可以使用菲律宾代理了！',
  VietnaAnswert2:
    '答：在IPRocket购买住宅代理后，跳转到获取代理界面，国家选择越南，州和城市可根据需求填写（没有需求即为空白），接着选择网络类型（socks5或http(s)），随后选择轮转模式或粘性模式，最后点击生成，复制生成的url到您的代码或浏览器中就可以使用越南代理了！',

  recommendT1: 'IPRocket推荐计划',
  recommendT2: '每个新人均可赚取高连10%的佣金资金，您帮到IPRocket的客户！',
  recommendT3: '成为会员',
  recommendT4: '会员登录',
  recommendT5: '业界领先的佣金',
  recommendT6: 'IPRocket的联盟计划可为您 赚取高达10%的佣金。',
  recommendT7: '永久利润',
  recommendT8: '从您推荐的注册用户的每笔订单中 获利关联！',
  recommendT9: '庞大的IP池',
  recommendT10: '超过8000万个住宅代理IP，覆盖全球210多个国家和地区,连接成功率高达99.86%',
  recommendT11: '7/24 技术支援',
  recommendT12: '专业技术团队7/24为您提供 全方位服务。',
  recommendT13: '它是如何运作的？',
  recommendT14: '提交您的申请并加入IPRocket的联盟合作伙伴网络。',
  recommendT15:
    '当您加入IPRocket时，您将获得3%的基本佣金份额，随着受邀用户采购订单的累积而增加达到一定金额，最多10%。你钱越多累积越多，报酬越多，没有上限。',
  recommendT16: '我该如何邀请他人',
  recommendT17: '成为 7600+ 的一部份 联盟网络',

  recommendStep: '步骤',
  recommendRegiter: '准备注册',
  recommendShare: '分享',
  recommendMnney: '赚钱',

  recommendText1: '注册或登入IPRrocket网站',
  recommendText2: '取得促销连接和邀请码并分享IPRrocket代理在您的网站或社交媒体上与您的受众提供解决方案。',
  recommendText3: '受邀用户完成注册购买后，即可收取佣金。',
  recommendText4: '受邀者透过您的邀请连接进入网站并完成注册。',
  recommendText5: '受邀者在注册时输入您的邀请码并完成注册。',

  commentName1: '克利夫兰德',
  commentName2: '德尔菲娅-约瑟琳-',
  commentName3: 'Kerrie Cathryn',
  commentPos1: '-首席技术官',
  commentPos2: '-WM公司',
  commentPos3: '-技术总监',
  commentCt1:
    '我一直在使用IPRocket 的住宅IP 进行网络搜刮，他们提供的服务水平给我留下了深刻印象。IP 是干净的，这对保持匿名性和避免封禁至关重要',
  commentCt2:
    'IPRocket 在数据收集方面的表现超出了我的预期。他们的旋转住宅代理在为我们的研究项目收集市场信息方面发挥了 重要作用。',
  commentCt3:
    '他们的应用程序接口(API)集成使其能够无缝地融入我们现有的工作流程。如果您需要可靠的代理服务来进行网络搜索或数据挖掘，IPRocket是您的不二之选。',

  contactyousName: '你的名字',
  contactyousEmail: '你的邮件',
  contactyousPhone: '你的号码',
  contactyousUrl: 'Url',
  contactyousType: '原因/类别',
  contactderide: '描述',
  contactpuloadImg: '上传图片',
  contactText1: '支付凭证注意事项： ·格式：jpg、jpeg 或 png.file ·大小：最大20MB',
  contactfile: '附件',
  contactpointUpImg: '点击上传文件',
  contactonlyPDF: '只能提交PDF文件，大小不能超过500K',
  contactclickSub: '单击“提交”即表示您同意IPRocket 隐私政策',
  contactSubmit: '提交',
  center: '仪表盘',
  clear: '退出',
  hotLocationTitle: '热门的住宅代理地点',

  '': '',
  aboutYear1: '2019年',
  aboutT1: 'IPRocket成立',
  aboutText1: 'IPRocket出现在市场上，使企业能够增强其数据收集实践并获取顶级的网络代理见解。',

  aboutYear2: '2021年',
  aboutT2: 'IPRocket率先结合人工智能技术',
  aboutText2: '行业领先的机器学习模型使我们的数据采集解决方案能够自动适应网站布局的变化。',

  aboutYear3: '2022年',
  aboutT3: '发布 Web Unblocker',
  aboutText3: 'IPRocket 将 Next-Gen Residential Proxies 更名为 Web Unblocker：一种由 AI 驱动的无阻塞抓取解决方案。',

  aboutYear4: '2024年',
  aboutT4: '代理池达到80M+ IP',
  aboutText4: 'IPRocket收购了世界上第三大的道德和合规组合代理池，在全球范围内提供超过80M个 IP。',
  proxy: '代理',
  getPrice: '定价',

  AntiBrowser: '指纹浏览器',
  Navigation: '跨境导航',
  Inspection: 'IP检测',
  bigData: '云手机及大数据',
  Payment: '支付及更多',
  partnershipTitle: '与我们合作',

  centerNav_t1: '余额：',
  centerNav_t2: '企业流量剩余',
  centerNav_t3: '个人计划流量剩余',
  centerNav_t4: '天过期',
  centerNav_t5: '个人信息',
  centerNav_t6: '退出登录',

  tabTitle: '住宅代理',
  tabTitle2: '高级住宅代理',
    tabTitle2_1: '高级',
    tabTitle2_2:'住宅代理',
  supHouse: '高级动态住宅代理',
  supText: '9000 多万真实 IP，支持http(s)和Socks协议',
  supHouseDes: '高级住宅代理：更纯净的IP池，速度更快',
  SupProductText:
    '高级住宅代理相比普通住宅代理，确保用户在进行数据采集、市场调研、账户管理等任务时，获得更高的匿名性和安全性。这种代理服务不仅可以有效规避IP封禁与限制，还能通过智能IP轮换功能，保证请求的顺利完成，适用于电商、社交媒体管理、网络爬虫等多个领域。',
  supAdv1: '可定位到国家、州/省和城市级别',
  supAdv2: '9000多万个真实IP',
  supAdv3: '无并发会话限制',
  supAdv4: '无带宽限制',
  supAdv5: '24/7技术支持',

  supFunTitle1: '无需合约',
  supFunDes1: '您无需签署任何复杂的合约或承诺书，即可开始使用我们的住宅代理。',
  supFunTitle2: '不限会话数量',
  supFunDes2: '我们对并发会话的数量没有限制——您需要多少就使用多少。',
  supFunTitle3: '可访问性',
  supFunDes3: '我们的住宅代理能够用于任何网站，因为我们没有访问限制。',
  supFunTitle4: '自动轮换',
  supFunDes4: '通过设置秒、分钟、小时的间隔来自动替换您的住宅代理IP。',
  supFunTitle5: '手动修改IP',
  supFunDes5: '切换您的住宅代理IP地址与一个单一的点击在仪表板可通过API请求。',
  supFunTitle6: '永远不会被屏蔽',
  supFunDes6: 'IP屏蔽无法与我们的住宅代理网络相匹配，因为您可以随时更改IP。',

  supPop: '受各大公司喜爱的高级住宅代理',
  supPopDes:
    '通过将我们的专有算法与IPRocket先进的住宅代理相结合，我们不仅彻底改变了我们代理网络连接的方法，而且显著增强了我们的网络爬行能力，最重要的是，使我们有了成本优势。',

  supReason: '为什么你应该使用IPRocket的高级住宅代理？',
  supReason1: '精准地理位置定位',
  supReasonDes1:
    '我们的住宅代理网络覆盖 210 个国家/地区，提供大陆、国家/地区、州、城市和ASN(运营商)定位。IPRocket代理可帮助访问受地理限制的内容，且不收取任何隐藏费用。',
  supReason2: '无限并发会话',
  supReasonDes2:
    '其他代理服务可能会对额外的并发会话收取额外费用，但在IPRocket，我们不限制并发会话，因此您可以随时轻松扩展您的网络抓取项目。',
  supReason3: '单个反向连接入口',
  supReasonDes3:
    '单个反向连接代理可让您访问不断轮换的代理池，让您能够控制会话并避免 IP 禁令和 CAPTHCA。作为回报，您的抓取项目可保证平均 99.86% 的成功率。',

  supRe1: '超大规模的住宅ip代理池',
  supReDes1: '我们提供最稳定的住宅代理IP池， 90M+IP供您使用。',
  supRe2: '零验证码',
  supReDes2: '由于无需处理 CAPTCHA，因此可以优化业务资源。',
  supRe3: '零 IP 阻止',
  supReDes3: '不需要浪费时间在IP封锁上了，购买住宅IP，专注于获取市场动态信息。',
  supRe4: '会话控制',
  supReDes4: 'IPRocket 出售的住宅代理具有轮转和粘性会话控制功能，可以满足您的各种业务需求。',
  supRe5: '无限带宽和并发会话',
  supReDes5: '没有带宽和并发限制和约束，购买住宅 IP，并发送无限数量的并发会话。',
  supRe6: '全球覆盖',
  supReDes6: '购买覆盖 210 个地点的住宅 IP，并提供大陆、国家、州级、城市和ASN(运营商)定位。',

  supAd: '专利解决方案',
  supAdDes:
    '我们的住宅代理网络采用专利技术，并采用最先进的传输层网络协议。尖端技术提高了我们网络的速度、可靠性和安全性，为用户提供无缝、不间断的抓取体验。我们利用最大、最稳定的住宅代理网络绕过地理限制，并由专利解决方案提供支持。',
  buyPlan: '购买计划',
  totalNum: '总购买量',
  supPerPlan: '高级个人计划',
  supEnPlan: '高级企业计划',
  exchangeSuccess: '兑换成功',

  saveMoney: '节省72%',
  startWith: '开始于',
  lastTime: '1-60分钟黏性会话',
  lastTime2: '1-60分钟黏性会话',
  autoChange: '自动代理轮换',

  buyGoods: '购买套餐',
  buyNeed: '购买你需要的',
  goodsType: '类型套餐',
  addProxy: '添加代理认证帐号',
  addD: '添加',
  proxyAccount: '注册代理账户',
  whiteName: '白名单',
  getProxy: '提取代理',
  selectTitle: '选择',
  andTitle: '和',
  getProxys: '获取代理',
  priceTitle: '高级住宅代理价格',
  priceTitle2: '住宅代理价格',

  notUse: '未生效流量包',
    howToUse: '查看历史明细',
    Detailed: '个人计划生效记录',
    DynamicResidence:'动态住宅',
  buyed: '购买流量(GB)',
  cityAll: '全部',
  ipError: '获取IP地址失败',
  currentIP: '当前IP:',
  notList: '尚未添加到白名单，请在生成前添加。',
  noFlow: '当前流量为0，请购买套餐。',
  warning: '警告',
  copyText: '复制成功',
  copyError: '请先生成数据',
  noMoney: '佣金不足',
  passwordType: '请输入由数字和大小写字母组成的15位密码',
  New:'全球210+ 个地点',
  New2:'自动代理轮换',
  New3:'平均 0.5 秒响应时间',
  New4:'6000万+ HttP(S)和SOCKS5 IP',
  New5:'平均 99.95% 的成功率',
  New6:'保持最佳下载速度',
  New7:'使用来自真人用户的 IP 地址实现更高的匿名性。访问更广泛的代理池，并减少网站的反爬虫措施带来的封锁。',
  New8:'起价',
  New9:'住宅代理非常适合需要持续监控和观察市场价格趋势的产品和服务。',
  New10:'网络营销',
  New11:'利用住宅代理的潜力，扩大市场覆盖范围，最大化您的营销影响。',
  New12:'住宅代理最常见的应用之一是监控并验证您页面上出现的广告。',
  New13:'网页抓取',
  New14:'网页抓取使您能够收集对您的业务决策至关重要的最新信息。',
  New15:'入门指南',
  New16:'教程文档',
  New17:'常见问题',
  New18:'快速开始',
  New19:'端点生成器',
  New20:'统计',
  New21:'新客户优惠',
  New22:'最受欢迎',
  New23:'总价',
  New24:'常规',
  New25:'企业',
  New26:'特征',
  New27:'稳定性极高，正常运行时间达 99.7％',
  New28:'价格低至 $0.65/GB 起',
  New29:'6000万+道德来源的住宅IP',
  New30:'平均99.82% 成功率',
  New31:'平均 0.41 秒回应时间',
  New32:'国家 / 州 / 城市 / 目标定位',
  New33:'抢购您的首单优惠',
  New34:'认证方式',
  New35:'选择账户身份认证方式，请选择您的代理用户账户和密码。选择白名单IP方式，我们会自动取得您加入的白名单代理。',   
    sele1:"通用",
    sele2:"亚洲",
    sele3:"欧洲",
    sele4:"美国",
    sele5:"微软",
    sele6:"国家专线",
    sele7:"地区专线",
    sele7_1:"运营商专线",
    sele8:"IPv4代理",
    sele9:"IPv6代理",
    sele10:"ISP代理",
  New36:'无与伦比的速度和可靠性，实现完全的抓取自由。',
  New37:'随用随付',
  New38:'了解更多',
  New39:'CDK兑换',
  New40:'开始',
  New41:'了解入库集成您的住宅代理',
  New42:'获取协助',
  New43:'需要协助为您的企业选择合适的产品吗？',
  New44:'套餐仅需',
  New45:'立即开始省钱',
  New46:'位置设定',
  New47:'国家列表',
  New48:'选择一个精确的代理位置或将“任意”保留为随机的代理位置。',
  New49:'会话设定',
  New50:'使用黏性会话可将相同的IP保留长达60分钟；选择轮换会话可以在每次请求时获取新的IP。',
  New51:'添加代理账户,',
  New52:'立即新增',
  New53:'推广分佣',
  New54:'我的账号',
  New55:'开始时间不能大于结束时间',
  New56:'CDKEY管理',
  New57:'生成明细',
  New58:'兑换明细',
  New59:'充值',
  New60:'剩余可用余额',
  New61:'从2GB开始',
  New61_2:'从100GB开始',
  New62:'兑换',
  New63:'CDKEY使用教程',
  New64:'步骤1',
  New65:'步骤2',
  New66:'步骤3',
  New67:'步骤4',
  New68:'步骤5',
  New69:'输入想要产生的流量/GB，从2GB开始。',
  New70:'输入生成CDKEY数量。',
  New71:'点击【兑换】按钮。',
  New72:'复制产生的CDKEY，并传送给其他使用者。',
  New73:'其他使用者复制您发送的CDKEY，前往个人账户的仪表板-进行CDKEY兑换即可。',
  myAccount: '我的账户',
  myProfile: '账户信息总览',
  personalInfo: '个人资料',
  accountName: '账户名称',
  accountID: '账户ID',
  emailName: '电子邮箱',
  password: '密码',
  strong_password_tip: '强密码可以让您的账户更加安全。建议您定期更改密码。',
  immediately_modify: '立即修改',
  basicInfo: '基本资讯',
  givenName: '名字',
  familyName: '姓氏',
  country: '国家',
  otherAccountInfo: '其他账号资讯',
  createTime: '创建时间',
  manageAccount: '管理账号',
  deleteAccount: '删除账号',
  save: '保存',
  New74:'导出',
  New75:'请输入1、2，或10的倍数',
  New75_1:'请输入10的倍数',
  New75_2:'请输入100的倍数',
  New75_3:'生成流量份数',
  New75_4:'最大支持生成/划转流量',
  New76:'生成日期',
  New77:'生成失败',
  New78:'受邀用户每次成功支付，您将获得收入的3%。',
  New79:'禁止在付费搜寻广告中竞标Thordata商标，我们保留暂停任何违反此规则的账户的权利。',
  New80:'如果您的受邀用户在佣金期间内取消订阅或产生退款，相应的佣金奖励将立即取消。',
  New81:'联盟计划',
  New82:'邀请明细',
  New83:'兑换明细',
  New84:'奖励明细',
  New85:'用户名',
  New86:'奖励余额',
  New87:'奖励总额',
  New88:'邀请总数',
  New88_2:' /位',
  New89:'返佣比例',
  New90:'奖励兑换',
  New91:'已兑换',
  New92:'兑换流量/GB',
  New93:'兑换',
  New94:'邀请码和链接',
  New95:'立即邀请',
  New96:'失败',
  New97:'邀请链接',
  New98:'活动规则',
  New99:'CDKEY',
  New100:'剩余流量',
  New101:'剩余企业流量',
  New102:'暂无CDKEY可复制',
  New103:'教程文档',
  New104:'常见问题',
  New105:'请输入有效数字',
  New106:'兑换数量不能少于10GB',
  New107:'兑换数量必须是10的倍数',
  New108:'请输入兑换数量',
  // 12.25后新增
  New109:'购买明细',
  New110:'余额明细',
  New111:'兑换记录',
  New112:'个人',
  New113:'cdkey使用记录',
  New114:'请选择兑换类型',
   New115:'流量套餐',
   New116:'待支付',
   New117:'(兑换金额不能超过奖励余额)',
   New118:'奖励余额不足',
     New119:'',
  New120:'续费',
  New121:'购买',
  New122:'用户账户',
  New123:'充值状态',
  New124:'请输入您的名字',
  New125:'请输入您的姓氏',
  New126:'请输入您的国家',
  New127:'长度应在8-15位之间',
  New128:'长度应在8-20位之间',
  New129:'',
  New130:'',
  New131:'请选择完整时间',
  New132:'未使用兑换码',
  New133:'请稍后再试',
  New134:'档位一：低档位',
  New135:'档位二：中档位',
  New136:'档位三：高档位',
  New137:'重要注意事项',
  New138:'广告限制',
  New139:'违规处罚',
  New140:'佣金',
  New141:'示例',
  New142:'退款政策',
  New143:'禁止在付费搜寻广告中竞标Thordata商标',
  New144:'违反规则的账户将被暂停',
  New145:'用户取消订阅或退款将取消对应佣金',
  New146:'佣金计算规则',
  New147:'规则执行流程',
  New148:'受邀用户完成支付',
  New149:'系统自动检测金额',
  New150:'计算并发放佣金',
  New151:'退款或取消订阅',
  New152:'广告投放限制',
  New153:'用户必须成功完成订阅支付，才会触发佣金计算。支付失败或取消订单不计入佣金。',
  New154:'系统实时检测用户兑换的实际金额，并根据金额大小自动匹配对应的佣金率档位。',
  New155:'按照确定的佣金率计算金额，计算公式：佣金 = 用户支付金额 × 佣金率。',
  New156:'佣金将在结算周期内自动发放到您的账户。',
  New157:'严禁在付费搜寻广告中竞标Thordata商标及相关关键词。',
  New158:'违规者将面临账户暂停处理，已产生佣金不予发放。',
  New159:'获取数据成功',
  New160:'获取数据失败',
  New161:'银联支付的金额不得超过4340美元',
  New162:'广告投放限制',
  New163:'广告投放限制',
  New164:'广告投放限制',
  New165:'广告投放限制',
  
  partnerTitle: '合作伙伴',
  partnerSubtitle: '探索我们的合作伙伴，使得业务快速的增长。',
  partnerAll: '全部',
  partnerBrowser: '指纹浏览器',
  partnerPayment: '支付',
  partnerTraffic: '流量',
  partnerVisit: '访问官网',
  partnerEmpty: '暂无合作伙伴数据',

  switchPool: '切换资源池，请咨询客服',
};
export default lang;
